import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import pathname from './constants/pathname'
import Landing from './pages/landing/Landing'
import Dashboard from './pages/dashboard/Dashboard'
import ProposalDashboard from './pages/proposal/ProposalDashboard'

import SubmitProposalView from './pages/proposal/SubmitProposalView'
import SubmitEditProposal from './pages/proposal/submitEditProposal/SubmitEditProposal'
import SummaryReviseRequest from './pages/proposal/summaryReviseRequest/SummaryReviseRequest'
import InviteToProject from './pages/proposal/InviteToProject'
import InviteToProjectAccept from './pages/proposal/InviteToProjectAccept'

import SelectProposalForm from './pages/proposal/SelectProposalForm'
import selectProposalFormDep6 from './pages/proposal/SelectProposalFormDep6'
import ProjectTypeInfoView from './pages/proposal/ProjectTypeInfo'
import TargetSettingView from './pages/proposal/TargetSettingView'

import FormDownloads from './pages/formDownloads/FormDownloads'

import Logon from './pages/Logon'
import RenderImg from './pages/RenderImg'

import ProjectName from './pages/proposal/ProjectName'
import BackgroundAndImportant from './pages/proposal/projectProposalView/BackgroundAndImportant'
import ObjectiveGoal from './pages/proposal/projectProposalView/ObjectiveGoal'
import ProposalGoal from './pages/proposal/goal/ProposalGoal'
import Budget from './pages/proposal/projectProposalView/Budget'
import ProjectManagementStructure from './pages/proposal/projectProposalView/ProjectManagementStructure'
import WorkingGroup from './pages/proposal/projectProposalView/WorkingGroup'
import MonitoringAndInternalEvaluation from './pages/proposal/projectProposalView/MonitoringAndInternalEvaluation'
import ExpectedResult from './pages/proposal/projectProposalView/ExpectedResult'
import sumamaryProposalFilter from './pages/proposal/projectProposalView/SumamaryProposalFilter'
import projectEvaluationProgress from './pages/proposal/projectEvaluationProgress/ProjectEvaluationProgress'
import projectEvaluationRelation from './pages/proposal/projectEvaluationRelation/ProjectEvaluationRelation'
import personalDataProtectionAct from './pages/proposal/personalDataProtectionAct/PersonalDataProtectionAct'

import ProposalGranteeBasicInfo from './pages/proposal/granteeBasicInfo/ProposalGranteeBasicInfo'
import ProposalResponsibleManBasicInfo from './pages/proposal/granteeBasicInfo/ProposalResponsibleManBasicInfo'
import GranteeProperty from './pages/proposal/projectProposalView/GranteeProperty'
import Overview from './pages/proposal/overview/overviewCoworker'

import PaymentPlanSave from './pages/review/paymentPlanSave/PaymentPlanSave'
import PaymentSave from './pages/review/paymentSave/PaymentSave'
import ProposalFilter6 from './pages/review/proposalFilter6/ProposalFilter6'
import ReviewSummary from './pages/review/reviewSummary/ReviewSummary'
import ReviewSummaryAttachFileCoi from './pages/review/reviewSummary/ReviewSummaryAttachFileCoi'
import ProposalRevise from './pages/review/proposalRevise/ProposalRevise'
import ProposalReviseResquest from './pages/review/proposalRevise/ProposalReviseResquest'
import ApproveReviewerRevise from './pages/review/proposalRevise/ApproveReviewerRevise'
import ProposalStrategic from './pages/review/prosalStrategic/ProposalStrategic'
import OutcomeIndicator from './pages/review/outcomeIndicator/OutcomeIndicator'
import AssignExpert from './pages/review/assignExpert/AssignExpert'
import SendAssignExpert from './pages/review/sendAssignExpert/SendAssignExpert'
import ProposalFilterOther from './pages/review/proposalFilterOther/ProposalFilterOther'
import ProposalFilterHistory from './pages/review/proposalHistory/ProposalFilterHistory'
import ProposalRevisionHistory from './pages/review/proposalHistory/ProposalRevisionHistory'
import ApproveProposal from './pages/review/approveProposal/ApproveProposal'
import ApproveExpert from './pages/review/approveExpert/ApproveExpert'
import ApproveExpertMulti from './pages/review/approveExpert/ApproveExpertMulti'
import PaymentCheckForReviewer from './pages/review/paymentCheckForReviewer/PaymentCheckForReviewer'
import PaymentCheckForDirector from './pages/review/paymentCheckForDirector/PaymentCheckForDirector'
import GranteeProfileInfoForDirector from './pages/review/granteeProfileInfoForDirector/GranteeProfileInfoForDirector'
import ApproveProject from './pages/review/approveProject/ApproveProject'
import AttachFilesView from './pages/proposal/AttachFilesView'
import AttachFilesAllView from './pages/proposal/AttachFilesAllView'
import attachFilesPDPA from './pages/proposal/AttachFilesPDPA'

import PaymentCheck from './pages/approve/paymentCheckForStaff/PaymentCheck'
import GranteeForStaff from './pages/approve/granteeForStaff/granteeForStaff'
import ProposeConsiderApproveProject from './pages/approve/proposeConsiderApproveProjectForStaff/ProposeConsiderApproveProject'
import projectApprovalSummaryForStaff from './pages/approve/projectApprovalSummaryForStaff/ProjectApprovalSummaryForStaff'
import ContractCenterCommentBeforeApprove from './pages/approve/contractCenterCommentBeforeApprove/ContractCenterCommentBeforeApprove'
import SentToFix from './pages/approve/sentToFix/SentToFix'
import StaffHistoryReviewApprove from './pages/approve/historyReviewStaffApprove/historyReviewStaffApprove'

import MakeContractView from './pages/proposal/makeContract/MakeContract'
import NotMakeContractView from './pages/proposal/makeContract/NotMakeContract'
import AgreementAdditionalView from './pages/proposal/makeContract/AgreementAdditional'
import EditContractView from './pages/proposal/makeContract/EditContractView'
import CoworkerSignatory from './pages/proposal/makeContract/CoworkerSignatory'
import AddAttachmentsContract from './pages/proposal/makeContract/AddAttachmentsContract'
import checkFundRecipients from './pages/proposal/staffContract/checkFundRecipients'
import checkContractAttachments from './pages/proposal/staffContract/checkContractAttachments'
import offerAuthorizedSignatoryStaff from './pages/proposal/staffContract/OfferAuthorizedSignatoryStaff'
import contractSigning from './pages/proposal/staffContract/ContractSigning'
import summaryProjectApprovalSenceStaff from './pages/proposal/staffContract/SummaryProjectApprovalSenceStaff'
import moreRequest from './pages/proposal/staffContract/MoreRequest'
import RequestNotMakeContract from './pages/proposal/staffContract/RequestNotMakeContract'
import SendApproveBankAccount from './pages/proposal/staffContract/SendApproveBankAccount'
import CenterRequestNotMakeContract from './pages/proposal/centerContract/CenterRequestNotMakeContract'
import DirectorRequestNotMakeContract from './pages/proposal/directorContract/DirectorRequestNotMakeContract'
import ApproveBankAccount from './pages/proposal/directorContract/ApproveBankAccount'
import ManagerRequestNotMakeContract from './pages/proposal/managerContract/ManagerRequestNotMakeContract'
import Uncertified from './pages/proposal/staffContract/Uncertified'
import moreRequestStaffEdit from './pages/proposal/staffContract/MoreRequestStaffEdit'
import centerCheckFundRecipients from './pages/proposal/centerContract/CenterCheckFundRecipients'
import centerCheckContractAttachments from './pages/proposal/centerContract/CenterCheckContractAttachments'
import centerAddBankAccount from './pages/proposal/centerContract/CenterAddBankAccount'
import centerOfferAuthorizedSignatory from './pages/proposal/centerContract/CenterOfferAuthorizedSignatory'
import CenterSubmitContract from './pages/proposal/centerContract/CenterSubmitContract'
import DirectorCheckFundRecipients from './pages/proposal/directorContract/DirectorCheckFundRecipients'
import DirectorContractAttachments from './pages/proposal/directorContract/DirectorContractAttachments'
import DirectorOfferAuthorizedSignatory from './pages/proposal/directorContract/DirectorOfferAuthorizedSignatory'
import DirectorMoreRequest from './pages/proposal/directorContract/DirectorMoreRequest'
import DirectorUncertified from './pages/proposal/directorContract/DirectorUncertified'
import DirectorMoreRequestEdit from './pages/proposal/directorContract/DirectorMoreRequestEdit'
import ManagerCheckFundRecipients from './pages/proposal/managerContract/ManagerCheckFundRecipients'
import ManagerContractAttachments from './pages/proposal/managerContract/ManagerContractAttachments'
import ManagerOfferAuthorizedSignatory from './pages/proposal/managerContract/ManagerOfferAuthorizedSignatory'
import ManagerUncertified from './pages/proposal/managerContract/ManagerUncertified'
import ReSendFile from './pages/proposal/centerContract/ReSendFile'

import ProgressReport from './pages/proposal/projectManagement/ProgressReport'
import WithdrawRequest from './pages/proposal/withdraw/WithdrawRequest'
import SendWithdrawRequest from './pages/proposal/withdraw/SendWithdrawRequest'
import ApproveWithdraw from './pages/proposal/withdraw/ApproveWithdraw'
import ProjectEvaluation from './pages/proposal/projectEvaluation/ProjectEvaluation'
import EndOfProject from './pages/proposal/EndOfProject/EndOfProject'
import EndOfProjectApprove from './pages/proposal/EndOfProject/EndOfProjectApprove'
import CloseOfProject from './pages/proposal/EndOfProject/CloseOfProject'
import CloseOfProjectStaff from './pages/proposal/EndOfProject/CloseOfProjectStaff'
import CloseOfProjectApprove from './pages/proposal/EndOfProject/CloseOfProjectApprove'
import DisclaimProjectCoworker from './pages/proposal/EndOfProject/DisclaimProjectCoworker'
import DisclaimProjectStaff from './pages/proposal/EndOfProject/DisclaimProjectStaff'
import DisclaimProjectDirector from './pages/proposal/EndOfProject/DisclaimProjectDirector'
import SuspendProjectStaff from './pages/proposal/EndOfProject/SuspendProjectStaff'
import CancelSuspendProjectStaff from './pages/proposal/EndOfProject/CancelSuspendProjectStaff'
import SuspendProjectDirector from './pages/proposal/EndOfProject/SuspendProjectDirector'
import CancelSuspendProjectDirector from './pages/proposal/EndOfProject/CancelSuspendProjectDirector'
import CancelProjectStaff from './pages/proposal/EndOfProject/CancelProjectStaff'
import CancelProjectLawyer from './pages/proposal/EndOfProject/CancelProjectLawyer'
import CancelProjectDirector from './pages/proposal/EndOfProject/CancelProjectDirector'
import CancelProjectHighDirector from './pages/proposal/EndOfProject/CancelProjectHighDirector'

import PreviewBeforePrint from './pages/proposal/PreviewBeforePrint'

import NotAccepted from './pages/review/notAccepted/NotAccepted'
import ReviewSend from './pages/review/reviewSend/ReviewSend'

import ProjectInfoAccordingReviewCycle from './pages/admin/report/ProjectInfoAccordingReviewCycle'
import PreApprovedProject from './pages/admin/report/PreApprovedProject'
import ApprovedProject from './pages/admin/report/ApprovedProject'
import ProjectActiveSeparateIssues from './pages/admin/report/ProjectActiveSeparateIssues'
import ProjectChangedStatusProcess from './pages/admin/report/ProjectChangedStatusProcess'
import ContractCenterProjectTracking from './pages/admin/report/ContractCenterProjectTracking'
import ProjectTracking from './pages/admin/report/ProjectTracking'
import ProjectClosedLate from './pages/admin/report/ProjectClosedLate'
import ProjectDisbursementByPeriod from './pages/admin/report/ProjectDisbursementByPeriod'
import SubProjectReportAdmin from './pages/admin/report/SubProjectReport'
import DocumentDeliveryAddress from './pages/admin/report/DocumentDeliveryAddress'
import ProjectApproved from './pages/admin/report/ProjectApproved'
import ActiveProjectForContract from './pages/admin/report/ActiveProjectForContract'
import ProjectWaitingForClose from './pages/admin/report/ProjectWaitingForClose'
import ProjectClose from './pages/admin/report/ProjectClose'
import ProjectGrant from './pages/admin/report/ProjectGrant'
import OverduePaymentPeriod from './pages/admin/report/OverduePaymentPeriod'
import ObligationOfInstallment from './pages/admin/report/ObligationOfInstallment'
import Obligation from './pages/admin/report/Obligation'
import BudgetApprovalReport from './pages/admin/report/BudgetApprovalReport'
import ConfirmActualResult from './pages/admin/report/ConfirmActualResult'
import AccessLoggerActivity from './pages/admin/report/AccessLoggerActivity'
import OverallDisbursementReport from './pages/admin/report/OverallDisbursementReport'

import AllProjectSummaryReport from './pages/admin/AllProjectSummaryReport'
import ManageProjectStatus from './pages/admin/manage/ManageProjectStatus'
import ManageProjectCoordinator from './pages/admin/manage/ManageProjectCoordinator'
import ManageProhibited from './pages/admin/manage/ManageProhibited'
import ManageCommitteeAccounts from './pages/admin/manage/ManageCommitteeAccounts'
import ManageExpertAccounts from './pages/admin/manage/ManageExpertAccounts'
import ManageExpertAccountsViewOnly from './pages/admin/manage/ManageExpertAccountsViewOnly'
import ManageProjectClosedLate from './pages/admin/manage/ManageProjectClosedLate'
import ManageLawProjectTracking from './pages/admin/manage/ManageLawProjectTracking'

import ProposalAllDetail from './pages/admin/report/ProposalAllDetail'
import ProjectGranteeBasicInfo from './pages/admin/report/ProjectGranteeBasicInfo'
import ProjectVenderList from './pages/admin/report/ProjectVenderList'

import ScrutinizeMethodSingle from './pages/review/ScrutinizeMethodSingle'
import MeetingSummarySingle from './pages/review/MeetingSummarySingle'
import AssignExpertMitting from './pages/review/assignExpert/AssignExpertMitting'

import ProjectList from './pages/review/projectList/ProjectList'
import ProposalStrategicMuti from './pages/review/prosalStrategic/ProposalStrategicMuti'
import PaymentPlanSaveMuti from './pages/review/paymentPlanSave/PaymentPlanSaveMuti'
import ScrutinizeMethod from './pages/review/ScrutinizeMethod'
import ReviewSummaryMulti from './pages/review/reviewSummary/ReviewSummaryMulti'
import ReviewResultsMulti from './pages/review/reviewSummary/ReviewResultsMulti'
import AssignExpertMulti from './pages/review/assignExpert/AssignExpertMulti'
import AssignExpertMittingMulti from './pages/review/assignExpert/AssignExpertMittingMulti'
import SendAssignExpertMulti from './pages/review/sendAssignExpert/SendAssignExpertMulti'
import PaymentSaveMulti from './pages/review/paymentSave/PaymentSaveMulti'
import AttendanceRecord from './pages/review/projectList/AttendanceRecord'
import AttendanceRecordSingle from './pages/review/projectList/AttendanceRecordSingle'
import MultiReviewGroup from './pages/review/projectList/MultiReviewGroup'

import SendWithdrawReview from './pages/admin/SendWithdrawReview'
import ApproveWithdrawReview from './pages/admin/ApproveWithdrawReview'
import SendWithdrawReviewByReviewer from './pages/admin/SendWithdrawReviewByReviewer'
import ApproveWithdrawReviewByReviewer from './pages/admin/ApproveWithdrawReviewByReviewer'
import EditPaymentPlanSave from './pages/proposal/withdraw/EditPaymentPlanSave'
import IntellectualProperty from './pages/proposal/intellectualProperty/IntellectualProperty'

import SaveReviewSubproject from './pages/subProject/reviewSubproject/saveReviewSubproject/SaveReviewSubproject'
import SubProjectDashboard from './pages/dashboard/SubProject'
import SubProjectPage from './pages/dashboard/SubProject'
import OverviewSubProject from './pages/subProject/overview/overviewCoworker'
import AssignExpertSub from './pages/subProject/reviewSubproject/assignExpert/AssignExpertSub'
import ReviewSummarySub from './pages/subProject/reviewSubproject/reviewSummary/ReviewSummarySub'

import SearchSubproject from './pages/subProject/projectMonitorRecord/SearchSubproject '
import ProjectMonitorRecord from './pages/subProject/projectMonitorRecord/ProjectMonitorRecord'
import ProjectInfoDoc from './pages/subProject/projectMonitorRecord/ProjectInfoDoc'
import SearchForNames from './pages/subProject/searchForNames/SearchForNames'
import ProjectIndicators from './pages/subProject/projectIndicators/ProjectIndicators'
import ProjectIndicatorsDetails from './pages/subProject/projectIndicators/ProjectIndicatorsDetails'
import TrackingHistory from './pages/subProject/trackingHistory/TrackingHistory'
import ProjectMonitorRecordFollow from './pages/subProject/projectMonitorRecordFollow/ProjectMonitorRecordFollow'
import CheckProjectQuality from './pages/subProject/checkProjectQuality/CheckProjectQuality'
import ProjectCommentsRecord from './pages/subProject/projectCommentsRecord/ProjectCommentsRecord'

import ProposalReviseSub from './pages/subProject/reviewSubproject/proposalRevise/ProposalReviseSub'
import SubProjectTypeInfo from './pages/subProject/projectTypeInfo/ProjectTypeInfo'
import PaymentSaveSub from './pages/subProject/reviewSubproject/PaymentSave/PaymentSaveSub'
import SubProjectContract from './pages/subProject/contract/SubProjectContract'
import TargetSettingSubProject from './pages/subProject/targetSetting/TargetSetting'
import SubProjectName from './pages/subProject/projectName/ProjectName'
import ObjectiveGoalSub from './pages/subProject/objectiveGoal/ObjectiveGoal'
import BudgetSubProject from './pages/subProject/budget/Budget'
import PaymentCheckSubproject from './pages/subProject/approveSubproject/paymentCheckForStaff/PaymentCheckSubproject'
import GranteeForStaffSubproject from './pages/subProject/approveSubproject/granteeForStaff/granteeForStaffSubproject'
import SentToFixSubproject from './pages/subProject/approveSubproject/sentToFix/SentToFix'
import SubProjectApprovalSummaryForStaff from './pages/subProject/approveSubproject/projectApprovalSummaryForStaff/ProjectApprovalSummaryForStaff'
import ProgressReportSubproject from './pages/subProject/projectManagement/ProgressReportSubproject'
import progressReportSubprojectClose from './pages/subProject/projectManagement/ProgressReportSubprojectClose'
import PeriodicFinancialReport from './pages/subProject/projectManagement/PeriodicFinancialReport'
import PeriodicFinancialReportClose from './pages/subProject/projectManagement/PeriodicFinancialReportClose'
import WithdrawRequestSubproject from './pages/subProject/withdraw/WithdrawRequestSubproject'
import GranteeBasicInfoSub from './pages/subProject/granteeBasicInfo/GranteeBasicInfoSubProject'
import ResponsibleManBasicInfoSub from './pages/subProject/granteeBasicInfo/ProposalResponsibleManBasicInfo'
import reportSetting from './pages/subProject/subProjectSetting/reportSetting/ReportSetting'
import manageUserGroups from './pages/subProject/subProjectSetting/UserRoleManagement/ManageUserGroups'
import manageUserRole from './pages/subProject/subProjectSetting/UserRoleManagement/ManageUserRole'
import ManageEvaluationTeamRole from './pages/subProject/subProjectSetting/UserRoleManagement/ManageEvaluationTeamRole'
import ImportUserRole from './pages/subProject/subProjectSetting/UserRoleManagement/ImportUserRole'
import SubApprovalFormReport from './pages/subProject/report/ApprovalFormReport'
import SubAummaryReport from './pages/subProject/report/SummaryReport'
import SubGrantReport from './pages/subProject/report/GrantReport'
import SubBillPaymentReport from './pages/subProject/report/BillPaymentReport'
import SubProjectApprovalReport from './pages/subProject/report/SubProjectApprovalReport'
import ProgressiveReport from './pages/subProject/report/ProgressiveReport'
import SaveProgressive from './pages/subProject/saveProgressive/SaveProgressive'
import ProjectControlReport from './pages/subProject/report/ProjectControlReport'
import SubProjectReport from './pages/subProject/report/SubProjectReport'
import InstallmentReport from './pages/subProject/report/InstallmentReport'
import UsesRoleSubProject from './pages/subProject/users/UsersRole'
import CreateUserSubProject from './pages/subProject/users/CreateUser'
import SubCloseProject from './pages/subProject/closeProject/CloseProject'
import ChangeSubProjectStatus from './pages/subProject/changeProjectStatus/ChangeSubProjectStatus'

import PaymentApproveRedirect from './pages/dashboard/PaymentApproveRedirect'
import ProjectApproveRedirect from './pages/dashboard/ProjectApproveRedirect'
import CloseProjectApproveRedirect from './pages/dashboard/CloseProjectApproveRedirect'
import ModifyContractApproveRedirect from './pages/dashboard/ModifyContractApproveRedirect'
import TerminateApproveRedirect from './pages/dashboard/TerminateApproveRedirect'

import { isAuthenticated, clearSession } from './redux/actions/auth'
import { config } from './config/config'

import ExEcharts from './pages/ExEcharts'
import Disclaim from './pages/Disclaim'
import DashboardSetting from './pages/setting/DashboardSetting'
import MeetingSummaryMulti from './pages/review/MeetingSummaryMulti'
import PaymentCheckMulti from './pages/approve/paymentCheckForStaff/PaymentCheckMulti'
import ProposeConsiderApproveProjectMulti from './pages/approve/proposeConsiderApproveProjectForStaff/ProposeConsiderApproveProjectMulti'

import ApproveProjectMulti from './pages/review/approveProject/ApproveProjectMulti'
import NotApproveProjectMulti from './pages/review/approveProject/NotApproveProjectMulti'
import ApproveCancelMulti from './pages/review/approveProject/ApproveCancelMulti'
import NotApproveCancelMulti from './pages/review/approveProject/NotApproveCancelMulti'
import ApproveClosureMulti from './pages/review/approveProject/ApproveClosureMulti'
import NotApproveClosureMulti from './pages/review/approveProject/NotApproveClosureMulti'
import ApproveDisbursementMulti from './pages/review/approveProject/ApproveDisbursementMulti'
import NotApproveDisbursementMulti from './pages/review/approveProject/NotApproveDisbursementMulti'
import ApproveEditContractMulti from './pages/review/approveProject/ApproveEditContractMulti'
import NotApproveEditContractMulti from './pages/review/approveProject/NotApproveEditContractMulti'
import ApproveTerminateMulti from './pages/review/approveProject/ApproveTerminateMulti'
import NotApproveTerminateMulti from './pages/review/approveProject/NotApproveTerminateMulti'

import ManageLegal from './pages/lawDepartment/legalManagement/LegalManagement'
import SaveLawList from './pages/lawDepartment/saveLawList/SaveLawList'
import SaveLawTracking from './pages/lawDepartment/saveLawTracking/SaveLawTracking'
import CallBookNotice from './pages/lawDepartment/callBookNotice/CallBookNotice'
import CheckNotice from './pages/lawDepartment/checkNotice/CheckNotice'
import DocumentOfTermination from './pages/lawDepartment/documentOfTermination/DocumentOfTermination'
import TrackingHistoryLaw from './pages/lawDepartment/trackingHistoryLaw/trackingHistoryLaw'
import LawDocumentform from './pages/lawDepartment/lawDocumentform/LawDocumentform'
import LawApprove from './pages/lawDepartment/lawApprove/LawApprove'

import ManageConsiderationRound from './pages/admin/manage/ManageConsiderationRound'

import MainIncomAndExpense from './pages/incomeAndExpense/mainIncomAndExpense/MainIncomAndExpense'

import AssessmentOfWorkingWithThaiHealth from './pages/proposal/assessment/AssessmentOfWorkingWithThaiHealth'
import ProjectBasedItems from './pages/incomeAndExpense/projectBasedItems/ProjectBasedItems'
import IncomeRecord from './pages/incomeAndExpense/incomeRecord/IncomeRecord'
import ExpenseRecord from './pages/incomeAndExpense/expenseRecord/ExpenseRecord'
import StrategyRegister from './pages/incomeAndExpense/strategyRegister/StrategyRegister'
import ManageSubStrategy from './pages/incomeAndExpense/strategyRegister/ManageSubStrategy'
import UpdateList from './pages/incomeAndExpense/updateList/UpdateList'
import ManageBankAccount from './pages/incomeAndExpense/manageBankAccount/ManageBankAccount'
import PaymentRecordAdvance from './pages/incomeAndExpense/paymentRecordAdvance/PaymentRecordAdvance'
import AdvanceRefund from './pages/incomeAndExpense/advanceRefund/AdvanceRefund'
import CreatePayeeAndTaxInfo from './pages/incomeAndExpense/createPayeeAndTaxInfo/CreatePayeeAndTaxInfo'
import DailyPayBook from './pages/incomeAndExpense/dailyPayBook/DailyPayBook'
import SubprojectExpenseRecord from './pages/incomeAndExpense/subprojectExpenseRecord/SubprojectExpenseRecord'
import SubProjectIncomeRecord from './pages/incomeAndExpense/subProjectIncomeRecord/SubProjectIncomeRecord'
import PeriodicManagement from './pages/incomeAndExpense/periodicManagement/PeriodicManagement'
import VoucherList from './pages/incomeAndExpense/voucherList/VoucherList'
import FinancialReportsDelivered from './pages/incomeAndExpense/report/financialReportsDelivered/FinancialReportsDelivered'

import AddDurableArticles from './pages/durableArticles/addDurableArticles/AddDurableArticles'
import ListDurableArticles from './pages/durableArticles/listDurableArticles/ListDurableArticles'
import ClosureRequestDurableArticles from './pages/durableArticles/closureRequest/ClosureRequestDurableArticles'
import AssetCounting from './pages/durableArticles/assetCounting/AssetCounting'
import AddAssetCounting from './pages/durableArticles/assetCounting/AddAssetCounting'

import AssetCountingSupplyOfficer from './pages/durableArticles/assetCounting/AssetCountingSupplyOfficer'
import AddAssetCountingSupplyOfficer from './pages/durableArticles/assetCounting/AddAssetCountingSupplyOfficer'
// import ApprovalCloseProject from './pages/durableArticles/approvalCloseProject/ApprovalCloseProject'
// import ClosureApproveRequest from './pages/durableArticles/closureApproveResuest/ClosureApproveRequest'
import BookingManagementScholars from './pages/durableArticles/bookingManagementScholars/BookingManagementScholars'
import SubProjectList from './pages/subProject/SubProjectList'
import AssetQrCodeReport from './pages/durableArticles/assetQrCodeReport/AssetQrCodeReport'
import AssetRegisterReport from './pages/durableArticles/assetRegisterReport/AssetRegisterReport'
import AssetStatusReport from './pages/durableArticles/assetStatusReport/AssetStatusReport'

import FinancialManagement from './pages/financialManagement/FinancialManagement'
import SubProjectBasedItems from './pages/incomeAndExpense/projectBasedItems/SubProjectBasedItems'
import SubProjectVoucherList from './pages/incomeAndExpense/voucherList/SubProjectVoucherList'
import SubProjectIncomeAndExpense from './widgets/dashboard/accounting/SubProjectIncomeAndExpense'
import BorrowAvanceVoucherList from './pages/incomeAndExpense/voucherList/BorrowAvanceVoucherList'
import UpdateListVoucherList from './pages/incomeAndExpense/voucherList/UpdateListVoucherList'
import ClosureDurableArticles from './pages/durableArticles/closureRequest/ClosureDurableArticles'
import {
  ClosureApproveApproveStep1,
  ClosureApproveRequestStep1,
  ClosureApproveRequestStep2,
  ClosureApproveApproveStep2,
} from './pages/durableArticles/closureApproveResuest/ClosureApproveStep'

import eFillingListForm from './pages/incomeAndExpense/eFillingListForm/eFillingListForm'
import ViewFileseFilling from './pages/incomeAndExpense/eFillingListForm/ViewFileseFilling'
import eFillingListReport from './pages/incomeAndExpense/eFillingListForm/eFillingListReport'
import eFillingSummaryReport from './pages/incomeAndExpense/eFillingListForm/eFillingSummaryReport'
import AnnualTaxRemittance from './pages/incomeAndExpense/eFillingListForm/AnnualTaxRemittance'
import OverallBudgetReport from './pages/incomeAndExpense/report/overallBudget/OverallBudgetReport'

import AddEvaluationPage from './pages/admin/report/AddEvaluationPage'
import AddEvaluationType from './pages/admin/report/AddEvaluationType'
import AddEvaluationForm from './pages/admin/report/AddEvaluationForm'
import EvaluationForm from './pages/admin/report/EvaluationForm'
import AddMasterQuestion from './pages/admin/report/AddMasterQuestion'
import ReportsAudit from './pages/audit/reportsAudit/ReportsAudit'
import AuditFileImport from './pages/audit/auditReportSummary/AuditFileImport'
import FollowAuditIssues from './pages/audit/followAuditIssues/FollowAuditIssues'
import AuditReportSummary from './pages/audit/auditReportSummary/AuditReportSummary'
import ListReportIssues from './pages/audit/listReportIssues/ListReportIssues'
import DirectorFollowAuditIssues from './pages/audit/directorFollowAuditIssues/DirectorFollowAuditIssues'
import FundManagerAuditIssues from './pages/audit/fundManagerAuditIssues/FundManagerAuditIssues'
import AuditDucumentManagement from './pages/audit/documentManagement/DocumentManagement'
import EmailAttManagement from './pages/audit/documentManagement/EmailAttManagement'
import CheckVoucherList from './pages/incomeAndExpense/voucherList/CheckVoucherList'
import ExpenseCheck from './pages/incomeAndExpense/expenseRecord/ExpenseCheck'
import PrepareProjectReview from './pages/audit/prepareProjectReview/PrepareProjectReview'
import AuditDashboard from './pages/audit/auditDashboard/AuditDashboard'
import BorrowAvanceReport from './pages/incomeAndExpense/report/borrowAvance/BorrowAvanceReport'
import AccountingSubProjectReport from './pages/incomeAndExpense/report/subProject/AccountingSubProjectReport'
import MainIncomAndExpenseApprover from './pages/incomeAndExpense/mainIncomAndExpense/MainIncomAndExpenseApprover'
import AssetRegisterReportApprover from './pages/durableArticles/assetRegisterReport/AssetRegisterReportApprover'
import AssetStatusReportApprover from './pages/durableArticles/assetStatusReport/AssetStatusReportApprover'
import Cash from './pages/incomeAndExpense/report/cash/Cash'
import Deposit from './pages/incomeAndExpense/report/deposit/Deposit'
import AssetHistory from './pages/durableArticles/assetList/AssetHistory'
import TaxSumReport from './pages/incomeAndExpense/report/taxSumReport/TaxSumReport'

import AssetSendBackEditLists from './pages/durableArticles/assetSendBackEditLists/AssetSendBackEditLists'

import AssetBookingManagement from './pages/durableArticles/assetBookingManagement/AssetBookingManagement'
import AssetBookingManagementDetail from './pages/durableArticles/assetBookingManagement/AssetBookingManagementDetail'
import AssetRequestManagement from './pages/durableArticles/assetRequestManagement/AssetRequestManagement'
import AssetRequestManagementDetail from './pages/durableArticles/assetRequestManagementDetail/AssetRequestManagementDetail'
import AssetRequestManagementApprove from './pages/durableArticles/assetRequestManagementApprove/AssetRequestManagementApprove'

import AssetBookingManagementOfficer from './pages/durableArticles/assetBookingManagement/AssetBookingManagementOfficer'
import AssetBookingManagementDetailOfficer from './pages/durableArticles/assetBookingManagement/AssetBookingManagementDetailOfficer'
import AssetBookingLists from './pages/durableArticles/assetBookingLists/AssetBookingLists'
import Blacklisted from './pages/blacklistPages/blacklisted/Blacklisted'
import AddBlacklist from './pages/blacklistPages/addBlacklist/AddBlacklist'
import CoworkerEvaluateThaihealth from './pages/evaluates/coworkerEvaluateThaihealth/CoworkerEvaluateThaihealth'
import CoworkerEvaluateYourself from './pages/evaluates/coworkerEvaluateYourself/CoworkerEvaluateYourself'
import CoordinatorEvaluateCoworker from './pages/evaluates/coordinatorEvaluateCoworker/CoordinatorEvaluateCoworker'
import DirectorEvaluateCloseProject from './pages/evaluates/directorEvaluateCloseProject/DirectorEvaluateCloseProject'
import ListOfAssets from './pages/durableArticles/assetList/ListOfAssets'
// import NotificationOfAssets from './pages/durableArticles/assetList/NotificationOfAssets'
import ListDepreciationAssets from './pages/durableArticles/listDepreciationAssets/ListDepreciationAssets'

import SearchExpertPayment from './pages/manageExpert/SearchExpertPayment'
import {
  ManageNotificationAsset,
  ManageNotificationElse,
} from './pages/admin/manage/ManageNotificationLanding'

import {
  ManageMasterDataPreName,
  ManageMasterDataSetting,
  ManageMasterDataTarget,
  ManageMasterDataIssue,
  ManageMasterDataLawType,
  ManageMasterDataLawStatus,
  ManageMasterDataLocationType,
  ManageMasterDataThaihealthPlan,
} from './pages/admin/manage/ManageMasterDataLanding'
import ManagePermissions from './pages/admin/manage/ManagePermissions'
import ManageHoliday from './pages/admin/manage/ManageHoliday'
import ContractChangeForm from './pages/proposal/centerContract/ContractChangeForm'
import InfomaUploadFiles from './pages/infoma/InfomaUploadFiles'
import ProjectBudgetReport from './pages/projectBudgetReport/ProjectBudgetReport'
import ProjectContractReport from './pages/projectBudgetReport/ProjectContractReport'

import DashboardNew from './pages/dashboard/DashboardNew'
import DashboardSettingNew from './pages/dashboard/DashboardSettingNew'
import IdentityLanding from './pages/thaIDIdentity/landing/Landing'
import ResultIdentity from './pages/thaIDIdentity/resultIdentity/ResultIdentity'
import MAndEForm from './pages/assessment/MAndEForm'
import PrePostTestForm from './pages/assessment/PrePostTestForm'
import MAndEMain from './pages/assessment/MAndEMain'
import MAndESelfForm from './pages/assessment/MAndESelfForm'
import MAndESelfMain from './pages/assessment/MAndESelfMain'
import MAndEManageCBTeam from './pages/assessment/MAndEManageCBTeam'
import ReportProjectManagement from './pages/assessment/ReportProjectManagement'
import ReportPartnerStrength from './pages/assessment/ReportPartnerStrength'
import PrePostTestPreview from './pages/assessment/PrePostTestPreview'
import ReprotHealthPromotionProject from './pages/assessment/ReprotHealthPromotionProject'
import ReprotCompetenciesAssessment from './pages/assessment/ReprotCompetenciesAssessment'
import ReprotCompetenciesPartner from './pages/assessment/ReprotCompetenciesPartner'
import ReportUnitCompetency from './pages/assessment/ReportUnitCompetency'
import ReportEvaluationScore from './pages/assessment/ReportEvaluationScore'
import ImportNodeData from './pages/assessment/ImportNodeData'
import MAndESelfFormUnauthorized from './pages/assessment/MAndESelfFormUnauthorized'
import MAndESelfMainAll from './pages/assessment/MAndESelfMainAll'
import MasterSeting from './pages/assessment/MasterSeting'
import CheckApproval from './pages/admin/manage/CheckApproval'
import AuditFileImportGeade from './pages/audit/auditReportSummary/AuditFileImportGeade'
import RedirectLink from './pages/redirectLink/RedirectLink'
import SubProjectNameNew from './pages/subProjectNew/proposal/SubProjectNameNew'
import ProjectProponent from './pages/subProjectNew/proposal/ProjectProponent'
import ProjectResponsibler from './pages/subProjectNew/proposal/ProjectResponsibler'
import ProjectCoMaker from './pages/subProjectNew/proposal/ProjectCoMaker'
import ProjectCoMaker2 from './pages/subProjectNew/proposal/ProjectCoMaker2'
import ProjectFeature from './pages/subProjectNew/proposal/ProjectFeature'
import OperatingPeriod from './pages/subProjectNew/proposal/OperatingPeriod'
import ProjectBackground from './pages/subProjectNew/proposal/ProjectBackground'
import OtherSupport from './pages/subProjectNew/proposal/OtherSupport'
import ProjectTargetOperationArea from './pages/subProjectNew/proposal/ProjectTargetOperationArea'
import ProjectObjectiveOutcomeIndicator from './pages/subProjectNew/proposal/ProjectObjectiveOutcomeIndicator'
import ResultsReport from './pages/subProjectNew/proposal/ResultsReport'
import Partner from './pages/subProjectNew/proposal/Partner'
import ProposalAttachments from './pages/subProjectNew/proposal/ProposalAttachments'
import Appendix from './pages/subProjectNew/proposal/Appendix'
import Activities from './pages/subProjectNew/proposal/Activities'
import SubProjectNameNewSetting from './pages/subProjectNew/proposal/SubProjectNameNewSetting'
import ProjectProponentSetting from './pages/subProjectNew/proposal/ProjectProponentSetting'
import OperatingPeriodSetting from './pages/subProjectNew/proposal/OperatingPeriodSetting'
import ProjectResponsiblerSetting from './pages/subProjectNew/proposal/ProjectResponsiblerSetting'
import ProjectCoMakerSetting from './pages/subProjectNew/proposal/ProjectCoMakerSetting'
import ProjectTargetOperationAreaSetting from './pages/subProjectNew/proposal/ProjectTargetOperationAreaSetting'
import OtherSupportSetting from './pages/subProjectNew/proposal/OtherSupportSetting'
import PartnerSetting from './pages/subProjectNew/proposal/PartnerSetting'
import ProposalAttachmentsSetting from './pages/subProjectNew/proposal/ProposalAttachmentsSetting'
import AppendixSetting from './pages/subProjectNew/proposal/AppendixSetting'
import ProjectObjectiveOutcomeIndicatorSetting from './pages/subProjectNew/proposal/ProjectObjectiveOutcomeIndicatorSetting'
import ActivitiesSetting from './pages/subProjectNew/proposal/ActivitiesSetting'
import ResultsReportSetting from './pages/subProjectNew/proposal/ResultsReportSetting'
import ProjectBackgroundSetting from './pages/subProjectNew/proposal/ProjectBackgroundSetting'
import ProjectFeatureSetting from './pages/subProjectNew/proposal/ProjectFeatureSetting'
import ManageProposalForm from './pages/subProjectNew/ManageProposalForm'
import PaymentSaveSubNew from './pages/subProject/reviewSubproject/PaymentSave/PaymentSaveSubNew'
import SaveReviewSubprojectNew from './pages/subProject/reviewSubproject/saveReviewSubproject/SaveReviewSubprojectNew'
import SubmitProposal from './pages/subProjectNew/SubmitProposal'
import ProjectListStatusReport from './pages/projectBudgetReport/ProjectListStatusReport'
import TempletDetailForm from './pages/subProjectNew/TempletDetailForm'
import SubProjectContractNew from './pages/subProject/contract/SubProjectContractNew'
import SubProjectProposalGoal from './pages/subProject/projectGoal/SubProjectProposalGoal'
import SubProjectExpectedResult from './pages/subProjectNew/proposal/SubProjectExpectedResult'
import ListOfAssetsOfficer from './pages/durableArticles/assetList/ListOfAssetsOfficer'
import ContractChangeFormHistory from './pages/proposal/centerContract/ContractChangeFormHistory'
import AIEvaluationReportPage from './pages/admin/report/AIEvaluationReportPage'
import ProjectBudgetPlanReport from './pages/admin/report/ProjectBudgetPlanReport'
import LandingDashboardOverview from './pages/dashboard/LandingDashboardOverview'
import SessionTimeoutProvider from './SessionTimeoutProvider'
import AssetMigration from './pages/durableArticles/assetMigration/AssetMigration'
import ContractChangeExtendPeriod from './pages/proposal/centerContract/ContractChangeExtendPeriod'
import ContractChangeExtendPeriodHistory from './pages/proposal/centerContract/ContractChangeExtendPeriodHistory'
import ExtentionTimePerProjectReport from './pages/admin/report/ExtentionTimePerProjectReport'
import ExtentionTimePerPeriodReport from './pages/admin/report/ExtentionTimePerPeriodReport'
import ExtentionTimeOverviewReport from './pages/admin/report/ExtentionTimeOverviewReport'
import { isEmpty } from 'lodash-es'
import ThangrathLanding from './pages/ThangrathLanding'
import OverlayLoader from './components/OverlayLoader/OverlayLoader'
import CloseOfProjectAfterClosed from './pages/proposal/EndOfProject/CloseOfProjectAfterClosed'
import eFillingListFormApprover from './pages/incomeAndExpense/eFillingListForm/eFillingListFormApprover'
import eFillingListReportApprover from './pages/incomeAndExpense/eFillingListForm/eFillingListReportApprover'
import eFillingSummaryReportApprover from './pages/incomeAndExpense/eFillingListForm/eFillingSummaryReportApprover'
import AnnualTaxRemittanceApprover from './pages/incomeAndExpense/eFillingListForm/AnnualTaxRemittanceApprover'
import ManageAssetRevolving from './pages/durableArticles/revolving/ManageAssetRevolving'
import MakeContractChangeWithdrawPerson from './pages/proposal/makeContract/MakeContractChangeWithdrawPerson'
import MakeContractChangeWithdrawPersonStaff from './pages/proposal/makeContract/MakeContractChangeWithdrawPersonStaff'
import MakeContractChangeWithdrawPersonApprover from './pages/proposal/makeContract/MakeContractChangeWithdrawPersonApprover'
import MakeContractChangeWithdrawPersonContractCenter from './pages/proposal/makeContract/MakeContractChangeWithdrawPersonContractCenter'

// 1. ย้าย PrivateRoute ออกมาประกาศด้านนอก Root Component
const PrivateRoute = (props) => {
  // สร้าง state สำหรับเก็บสถานะการตรวจสอบสิทธิ์ (null = กำลังโหลด, true = ผ่าน, false = ไม่ผ่าน)
  const [isA, setIsA] = useState(null)

  useEffect(() => {
    sessionStorage.removeItem('redirect-link')

    // เรียกฟังก์ชันตรวจสอบสิทธิ์
    // สมมติว่า isAuthenticated() คืนค่ากลับมาเป็น Promise (Async/Await)
    const checkAuth = async () => {
      try {
        const result = await isAuthenticated()
        console.log('isA result : ', result)
        setIsA(result) // เก็บผลลัพธ์ลง state
      } catch (error) {
        console.error(error)
        setIsA(false) // หาก error ให้เป็น false
      }
    }

    checkAuth()
  }, [props.path]) // รันใหม่ทุกครั้งที่เปลี่ยน path

  // 2. ระหว่างที่รอ isAuthenticated() ทำงานให้เสร็จ (isA ยังเป็น null)
  if (isA === null) {
    return (
      <div
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
      >
        <OverlayLoader />
      </div>
    )
  }

  // 3. เมื่อได้ผลลัพธ์มาแล้วว่าเป็น True (Authenticated)
  if (isA) {
    return (
      <SessionTimeoutProvider>
        <Route {...props} />
      </SessionTimeoutProvider>
    )
  }

  // 4. ถ้าได้ผลลัพธ์เป็น False (Not Authenticated)
  clearSession(null)

  return (
    <Route
      component={() => {
        sessionStorage.setItem('projectId', '')
        sessionStorage.setItem('param', '')
        var path = window.location.pathname + window.location.search

        var href = '/'
        if (path?.startsWith('/redirect-link?')) {
          sessionStorage.setItem('redirect-link', path)
          href = config.defaultLoginUrl
        } else if (path?.startsWith('/dashboard')) {
          const params = new URLSearchParams(window.location.search) // แก้เป็น window.location
          let appId = params.get('appId')
          let mToken = params.get('mToken')

          if (!isEmpty(appId) && !isEmpty(mToken)) {
            href = pathname.thangrathLanding + `?appId=${appId}&&mToken=${mToken}`
          } else {
            href = config.defaultLoginUrl
          }
        } else {
          sessionStorage.setItem('openLogin', true)
        }

        window.location.href = href
        window.opener = null
        return null
      }}
    />
  )
}

export default function Root() {
  // const PrivateRoute = (props) => {
  //   sessionStorage.removeItem('redirect-link')

  //   var isA = isAuthenticated()
  //   console.log('isA : ', isA)

  //   if (isA) {
  //     return (
  //       <SessionTimeoutProvider>
  //         <Route {...props} />
  //       </SessionTimeoutProvider>
  //     )
  //   }

  //   clearSession(null)

  //   return (
  //     <Route
  //       component={() => {
  //         sessionStorage.setItem('projectId', '')
  //         sessionStorage.setItem('param', '')
  //         var path = window.location.pathname + window.location.search

  //         var href = '/'
  //         if (path?.startsWith('/redirect-link?')) {
  //           sessionStorage.setItem('redirect-link', path)
  //           href = config.defaultLoginUrl
  //         } else if (path?.startsWith('/dashboard')) {
  //           const params = new URLSearchParams(location.search)
  //           let appId = params.get('appId')
  //           let mToken = params.get('mToken')

  //           if (!isEmpty(appId) && !isEmpty(mToken)) {
  //             href = pathname.thangrathLanding + `?appId=${appId}&&mToken=${mToken}`
  //           } else {
  //             href = config.defaultLoginUrl
  //           }
  //         } else {
  //           sessionStorage.setItem('openLogin', true)
  //         }

  //         window.location.href = href
  //         window.opener = null
  //         return null
  //       }}
  //       // component={() => {
  //       //   window.location.href = `${process.env.REACT_APP_SERVER_URL}/errorpage/404.html`
  //       //   window.opener = null
  //       //   return null
  //       // }}
  //     />
  //   )
  // }

  return (
    <div>
      <Router>
        <Switch>
          <Route path={'/'} exact component={Landing} />
          <Route path={pathname.logon} exact component={Logon} />
          <Route path={pathname.renderimg} exact component={RenderImg} />
          <Route path={pathname.formDownloads} exact component={FormDownloads} />
          <Route path={pathname.thangrathLanding} exact component={ThangrathLanding} />

          <Route
            path={`${pathname.assessment.assessmentPrePostTest}`}
            exact
            component={PrePostTestForm}
          />
          <Route
            path={`${pathname.assessment.assessmentMAndESelfInputForm}`}
            exact
            component={MAndESelfFormUnauthorized}
          />

          {/* Ex. Echarts */}
          <PrivateRoute path={pathname.echarts} exact component={ExEcharts} />
          <Route path={pathname.disclaim} exact component={Disclaim} />
          <PrivateRoute path={pathname.redirectLink} exact component={RedirectLink} />
          {/* <PrivateRoute
            path={pathname.setting.dashboardSetting}
            exact
            component={DashboardSetting}
          /> */}
          <PrivateRoute path={pathname.dashboardRoot} exact component={Dashboard} />
          <PrivateRoute
            path={pathname.dashboardRootSetting}
            exact
            component={DashboardSettingNew}
          />

          <PrivateRoute
            path={pathname.proposal.assessment.dashboard}
            exact
            component={LandingDashboardOverview}
          />

          {/* <PrivateRoute path={pathname.dashboardNew} exact component={DashboardNew} /> */}
          <PrivateRoute path={pathname.proposalRoot} exact component={ProposalDashboard} />
          <PrivateRoute
            path={pathname.proposal.selectProposalForm}
            exact
            component={SelectProposalForm}
          />
          <PrivateRoute
            path={pathname.proposal.selectProposalFormDep6}
            exact
            component={selectProposalFormDep6}
          />
          <PrivateRoute
            path={`${pathname.proposal.overview.submit}`}
            exact
            component={SubmitProposalView}
          />
          <PrivateRoute
            path={`${pathname.proposal.overview.summaryReviseRequest}`}
            exact
            component={SummaryReviseRequest}
          />
          <PrivateRoute
            path={`${pathname.proposal.overview.submitEdit}`}
            exact
            component={SubmitEditProposal}
          />
          {/* คำเชิญ Start */}
          <PrivateRoute
            path={`${pathname.proposal.inviteToProject}`}
            exact
            component={InviteToProject}
          />
          <Route
            path={`${pathname.manageInviteProject}/:se`}
            exact
            component={InviteToProjectAccept}
          />
          <PrivateRoute
            path={`${pathname.proposal.inviteToProjectAcceptance}`}
            exact
            component={InviteToProjectAccept}
          />
          {/* คำเชิญ END */}
          <PrivateRoute path={`${pathname.proposal.projectName}`} exact component={ProjectName} />
          <PrivateRoute
            path={`${pathname.proposal.backgroundAndImportant}`}
            exact
            component={BackgroundAndImportant}
          />
          <PrivateRoute
            path={`${pathname.proposal.objectiveGoal}`}
            exact
            component={ObjectiveGoal}
          />
          <PrivateRoute
            path={`${pathname.proposal.projectTypeInfo}`}
            exact
            component={ProjectTypeInfoView}
          />
          <PrivateRoute path={`${pathname.proposal.goal}`} exact component={ProposalGoal} />
          <PrivateRoute
            path={`${pathname.proposal.targetSetting}`}
            exact
            component={TargetSettingView}
          />
          <PrivateRoute path={`${pathname.proposal.budget}`} exact component={Budget} />
          <PrivateRoute
            path={`${pathname.proposal.projectManagementStructure}`}
            exact
            component={ProjectManagementStructure}
          />
          <PrivateRoute path={`${pathname.proposal.workingGroup}`} exact component={WorkingGroup} />
          <PrivateRoute
            path={`${pathname.proposal.monitoringAndInternalEvaluation}`}
            exact
            component={MonitoringAndInternalEvaluation}
          />
          <PrivateRoute
            path={`${pathname.proposal.expectedResult}`}
            exact
            component={ExpectedResult}
          />
          <PrivateRoute
            path={`${pathname.proposal.sumamaryProposalFilter}`}
            exact
            component={sumamaryProposalFilter}
          />
          <PrivateRoute
            path={`${pathname.proposal.personalDataProtectionAct}`}
            exact
            component={personalDataProtectionAct}
          />
          <PrivateRoute
            path={`${pathname.proposal.projectEvaluationProgress}`}
            exact
            component={projectEvaluationProgress}
          />
          <PrivateRoute
            path={`${pathname.proposal.projectEvaluationRelation}`}
            exact
            component={projectEvaluationRelation}
          />
          <PrivateRoute
            path={`${pathname.proposal.granteeBasicInfo}`}
            exact
            component={ProposalGranteeBasicInfo}
          />
          <PrivateRoute
            path={`${pathname.proposal.responsibleManBasicInfo}`}
            exact
            component={ProposalResponsibleManBasicInfo}
          />
          <PrivateRoute
            path={`${pathname.proposal.granteeProperty}`}
            exact
            component={GranteeProperty}
          />
          <PrivateRoute
            path={`${pathname.proposal.overview.overviewCoworker}`}
            exact
            component={Overview}
          />
          <PrivateRoute
            path={`${pathname.proposal.attachFiles}`}
            exact
            component={AttachFilesView}
          />
          <PrivateRoute
            path={`${pathname.proposal.allAttachFiles}`}
            exact
            component={AttachFilesAllView}
          />
          <PrivateRoute
            path={`${pathname.proposal.attachFilesPDPA}`}
            exact
            component={attachFilesPDPA}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.proposalFilter6}`}
            exact
            component={ProposalFilter6}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.proposalFilter}`}
            exact
            component={ProposalFilterOther}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.proposalFilterHistory}`}
            exact
            component={ProposalFilterHistory}
          />
          <PrivateRoute
            path={`${pathname.proposal.proposalRevisionHistory}`}
            exact
            component={ProposalRevisionHistory}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.strategic}`}
            exact
            component={ProposalStrategic}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.outcomeIndicator}`}
            exact
            component={OutcomeIndicator}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.paymentPlanSave}`}
            exact
            component={PaymentPlanSave}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.mittingAssign}`}
            exact
            component={AssignExpertMitting}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.attendanceRecord}`}
            exact
            component={AttendanceRecordSingle}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.scrutinizeMethodSingle}`}
            exact
            component={ScrutinizeMethodSingle}
          />
          {/* ผลการประชุม */}
          <PrivateRoute
            path={`${pathname.proposal.review.meetingSummarySingle}`}
            exact
            component={MeetingSummarySingle}
          />
          {/* ผลการประชุม หลายโครงการ*/}
          <PrivateRoute
            path={`${pathname.proposal.review.meetingSummaryMulti}`}
            exact
            component={MeetingSummaryMulti}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.paymentSave}`}
            exact
            component={PaymentSave}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.assign}`}
            exact
            component={AssignExpert}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.sendAssign}`}
            exact
            component={SendAssignExpert}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.reviewSummary}`}
            exact
            component={ReviewSummary}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.reviewSummaryAttachFileCoi}`}
            exact
            component={ReviewSummaryAttachFileCoi}
          />

          <PrivateRoute
            path={`${pathname.proposal.review.proposalRevise}`}
            exact
            component={ProposalRevise}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.proposalReviseRequest}`}
            exact
            component={ProposalReviseResquest}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.approveReviewerRevise}`}
            exact
            component={ApproveReviewerRevise}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.approveProposal}`}
            exact
            component={ApproveProposal}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.approveReviewer}`}
            exact
            component={ApproveExpert}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.approveReviewerMulti}`}
            exact
            component={ApproveExpertMulti}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.paymentCheckForReviewer}`}
            exact
            component={PaymentCheckForReviewer}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.paymentCheckForDirector}`}
            exact
            component={PaymentCheckForDirector}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.granteeProfileInfoForDirector}`}
            exact
            component={GranteeProfileInfoForDirector}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.approveProject}`}
            exact
            component={ApproveProject}
          />
          <PrivateRoute
            path={`${pathname.proposal.projectEvaluation}`}
            exact
            component={ProjectEvaluation}
          />
          <PrivateRoute path={`${pathname.proposal.endOfProject}`} exact component={EndOfProject} />
          <PrivateRoute
            path={`${pathname.proposal.endOfProjectApprove}`}
            exact
            component={EndOfProjectApprove}
          />
          <PrivateRoute
            path={`${pathname.proposal.closeOfProject}`}
            exact
            component={CloseOfProject}
          />
          <PrivateRoute
            path={`${pathname.proposal.closeOfProjectAfterClosed}`}
            exact
            component={CloseOfProjectAfterClosed}
          />
          <PrivateRoute
            path={`${pathname.proposal.closeOfProjectStaff}`}
            exact
            component={CloseOfProjectStaff}
          />
          <PrivateRoute
            path={`${pathname.proposal.closeOfProjectApprove}`}
            exact
            component={CloseOfProjectApprove}
          />
          <PrivateRoute
            path={`${pathname.proposal.coworkerDisclaimProject}`}
            exact
            component={DisclaimProjectCoworker}
          />
          <PrivateRoute
            path={`${pathname.proposal.staffDisclaimProject}`}
            exact
            component={DisclaimProjectStaff}
          />
          <PrivateRoute
            path={`${pathname.proposal.directorDisclaimProject}`}
            exact
            component={DisclaimProjectDirector}
          />
          <PrivateRoute
            path={`${pathname.proposal.staffSuspendProject}`}
            exact
            component={SuspendProjectStaff}
          />
          <PrivateRoute
            path={`${pathname.proposal.staffCancelSuspendProject}`}
            exact
            component={CancelSuspendProjectStaff}
          />
          <PrivateRoute
            path={`${pathname.proposal.directorSuspendProject}`}
            exact
            component={SuspendProjectDirector}
          />
          <PrivateRoute
            path={`${pathname.proposal.directorCancelSuspendProject}`}
            exact
            component={CancelSuspendProjectDirector}
          />
          <PrivateRoute
            path={`${pathname.proposal.staffCancelProject}`}
            exact
            component={CancelProjectStaff}
          />
          <PrivateRoute
            path={`${pathname.proposal.directorCancelProject}`}
            exact
            component={CancelProjectDirector}
          />
          <PrivateRoute
            path={`${pathname.proposal.highDirectorCancelProject}`}
            exact
            component={CancelProjectHighDirector}
          />
          <PrivateRoute
            path={`${pathname.proposal.lawyerCancelProject}`}
            exact
            component={CancelProjectLawyer}
          />
          <PrivateRoute
            path={`${pathname.proposal.previewBeforePrint}`}
            exact
            component={PreviewBeforePrint}
          />
          <PrivateRoute
            path={`${pathname.proposal.approve.paymentCheck}`}
            exact
            component={PaymentCheck}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.paymentCheckMulti}`}
            exact
            component={PaymentCheckMulti}
          />
          <PrivateRoute
            path={`${pathname.proposal.approve.granteeForStaff}`}
            exact
            component={GranteeForStaff}
          />
          <PrivateRoute
            path={`${pathname.proposal.approve.ProposeConsiderApproveProject}`}
            exact
            component={ProposeConsiderApproveProject}
          />
          {/* เสนอพิจารณาอนุมัติหลายโครงการ */}
          <PrivateRoute
            path={`${pathname.proposal.review.ProposeConsiderApproveProjectMulti}`}
            exact
            component={ProposeConsiderApproveProjectMulti}
          />
          <PrivateRoute
            path={`${pathname.proposal.approve.projectApprovalSummaryForStaff}`}
            exact
            component={projectApprovalSummaryForStaff}
          />
          <PrivateRoute
            path={`${pathname.proposal.approve.contractCenterCommentBeforeApprove}`}
            exact
            component={ContractCenterCommentBeforeApprove}
          />
          <PrivateRoute
            path={`${pathname.proposal.approve.sentToFix}`}
            exact
            component={SentToFix}
          />
          <PrivateRoute
            path={`${pathname.proposal.approve.StaffHistoryReviewApprove}`}
            exact
            component={StaffHistoryReviewApprove}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.notMakeContract}`}
            exact
            component={NotMakeContractView}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.makeContract}`}
            exact
            component={MakeContractView}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.makeContractChangeWithdrawPerson}`}
            exact
            component={MakeContractChangeWithdrawPerson}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.makeContractChangeWithdrawPersonStaff}`}
            exact
            component={MakeContractChangeWithdrawPersonStaff}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.makeContractChangeWithdrawPersonApprover}`}
            exact
            component={MakeContractChangeWithdrawPersonApprover}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.makeContractChangeWithdrawPersonContractCenter}`}
            exact
            component={MakeContractChangeWithdrawPersonContractCenter}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.AgreementAdditionalView}`}
            exact
            component={AgreementAdditionalView}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.editContractView}`}
            exact
            component={EditContractView}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.coworkerSignatory}`}
            exact
            component={CoworkerSignatory}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.addAttachmentsContract}`}
            exact
            component={AddAttachmentsContract}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.checkFundRecipients}`}
            exact
            component={checkFundRecipients}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.checkContractAttachments}`}
            exact
            component={checkContractAttachments}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.offerAuthorizedSignatoryStaff}`}
            exact
            component={offerAuthorizedSignatoryStaff}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.contractSigning}`}
            exact
            component={contractSigning}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.summaryProjectApprovalSenceStaff}`}
            exact
            component={summaryProjectApprovalSenceStaff}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.moreRequest}`}
            exact
            component={moreRequest}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.staffSendApproveBankAccount}`}
            exact
            component={SendApproveBankAccount}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.directorMoreRequest}`}
            exact
            component={DirectorMoreRequest}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.directorMoreRequestEdit}`}
            exact
            component={DirectorMoreRequestEdit}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.requestNotMakeContract}`}
            exact
            component={RequestNotMakeContract}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.centerRequestNotMakeContract}`}
            exact
            component={CenterRequestNotMakeContract}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.directorRequestNotMakeContract}`}
            exact
            component={DirectorRequestNotMakeContract}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.directorApproveBankAccount}`}
            exact
            component={ApproveBankAccount}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.managerRequestNotMakeContract}`}
            exact
            component={ManagerRequestNotMakeContract}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.uncertified}`}
            exact
            component={Uncertified}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.directorUncertified}`}
            exact
            component={DirectorUncertified}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.managerUncertified}`}
            exact
            component={ManagerUncertified}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.moreRequestStaffEdit}`}
            exact
            component={moreRequestStaffEdit}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.centerCheckFundRecipients}`}
            exact
            component={centerCheckFundRecipients}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.centerCheckContractAttachments}`}
            exact
            component={centerCheckContractAttachments}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.centerAddBankAccount}`}
            exact
            component={centerAddBankAccount}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.centerOfferAuthorizedSignatory}`}
            exact
            component={centerOfferAuthorizedSignatory}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.centerSubmitContract}`}
            exact
            component={CenterSubmitContract}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.directorCheckFundRecipients}`}
            exact
            component={DirectorCheckFundRecipients}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.directorCheckContractAttachments}`}
            exact
            component={DirectorContractAttachments}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.directorOfferAuthorizedSignatory}`}
            exact
            component={DirectorOfferAuthorizedSignatory}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.managerCheckFundRecipients}`}
            exact
            component={ManagerCheckFundRecipients}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.managerCheckContractAttachments}`}
            exact
            component={ManagerContractAttachments}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.managerOfferAuthorizedSignatory}`}
            exact
            component={ManagerOfferAuthorizedSignatory}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.reSendFile}`}
            exact
            component={ReSendFile}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.contractChangeForm}`}
            exact
            component={ContractChangeForm}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.contractChangeFormHistory}`}
            exact
            component={ContractChangeFormHistory}
          />
          <PrivateRoute
            path={`${pathname.proposal.projectManagement.progressReport}`}
            exact
            component={ProgressReport}
          />
          <PrivateRoute
            path={`${pathname.proposal.projectManagement.withdrawRequest}`}
            exact
            component={WithdrawRequest}
          />
          <PrivateRoute
            path={`${pathname.proposal.projectManagement.sendWithdrawRequest}`}
            exact
            component={SendWithdrawRequest}
          />
          <PrivateRoute
            path={`${pathname.proposal.projectManagement.approveWithdraw}`}
            exact
            component={ApproveWithdraw}
          />
          <PrivateRoute
            path={`${pathname.proposal.projectManagement.editPaymentPlan}`}
            exact
            component={EditPaymentPlanSave}
          />
          <PrivateRoute
            path={`${pathname.proposal.projectManagement.intellectualProperty}`}
            exact
            component={IntellectualProperty}
          />

          <PrivateRoute
            path={`${pathname.proposal.projectManagement.paymentReceipt}`}
            exact
            component={Budget}
          />
          <PrivateRoute
            path={`${pathname.proposal.notaccepted.reviewNotaccepted}`}
            exact
            component={NotAccepted}
          />
          {/* multi review */}
          <PrivateRoute
            path={`${pathname.proposal.review.projectList}`}
            exact
            component={ProjectList}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.strategicMulti}`}
            exact
            component={ProposalStrategicMuti}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.paymentPlanSaveMulti}`}
            exact
            component={PaymentPlanSaveMuti}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.scrutinizeMethodMuti}`}
            exact
            component={ScrutinizeMethod}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.reviewSummaryMulti}`}
            exact
            component={ReviewSummaryMulti}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.reviewResultMulti}`}
            exact
            component={ReviewResultsMulti}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.assignMulti}`}
            exact
            component={AssignExpertMulti}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.mittingAssignMulti}`}
            exact
            component={AssignExpertMittingMulti}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.sendAssignMulti}`}
            exact
            component={SendAssignExpertMulti}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.paymentSaveMulti}`}
            exact
            component={PaymentSaveMulti}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.reviewListMulti}`}
            exact
            component={MultiReviewGroup}
          />
          <PrivateRoute
            path={`${pathname.proposal.review.attendanceRecordMulti}`}
            exact
            component={AttendanceRecord}
          />
          {/*รออนุมัติหลายโครงการ*/}
          {/*อนุมัติ*/}
          <PrivateRoute
            path={`${pathname.proposal.approve.approveProjectMulti}`}
            exact
            component={ApproveProjectMulti}
          />
          {/*ไม่อนุมัติ*/}
          <PrivateRoute
            path={`${pathname.proposal.approve.notApproveProjectMulti}`}
            exact
            component={NotApproveProjectMulti}
          />
          {/* อนุมัติแก้ไขสัญญาหลายโครงการ */}
          {/*อนุมัติ*/}
          <PrivateRoute
            path={`${pathname.proposal.approve.approveContractMulti}`}
            exact
            component={ApproveEditContractMulti}
          />
          {/*ไม่อนุมัติ*/}
          <PrivateRoute
            path={`${pathname.proposal.approve.notApproveContractMulti}`}
            exact
            component={NotApproveEditContractMulti}
          />
          {/* อนุมัติเบิกจ่ายหลายโครงการ */}
          {/*อนุมัติ*/}
          <PrivateRoute
            path={`${pathname.proposal.approve.approveDisbursementMulti}`}
            exact
            component={ApproveDisbursementMulti}
          />
          {/*ไม่อนุมัติ*/}
          <PrivateRoute
            path={`${pathname.proposal.approve.notApproveDisbursementMulti}`}
            exact
            component={NotApproveDisbursementMulti}
          />
          {/* อนุมัติปิดหลายโครงการ */}
          {/*อนุมัติ*/}
          <PrivateRoute
            path={`${pathname.proposal.approve.approveClosureMulti}`}
            exact
            component={ApproveClosureMulti}
          />
          {/*ไม่อนุมัติ*/}
          <PrivateRoute
            path={`${pathname.proposal.approve.notApproveClosureMulti}`}
            exact
            component={NotApproveClosureMulti}
          />
          {/* อนุมัติยุติหลายโครงการ */}
          {/*อนุมัติ*/}
          <PrivateRoute
            path={`${pathname.proposal.approve.approveTerminateMulti}`}
            exact
            component={ApproveTerminateMulti}
          />
          {/*ไม่อนุมัติ*/}
          <PrivateRoute
            path={`${pathname.proposal.approve.notApproveTerminateMulti}`}
            exact
            component={NotApproveTerminateMulti}
          />
          {/* อนุมัติยกเลิกหลายโครงการ */}
          {/*อนุมัติ*/}
          <PrivateRoute
            path={`${pathname.proposal.approve.approveCancelMulti}`}
            exact
            component={ApproveCancelMulti}
          />
          {/*ไม่อนุมัติ*/}
          <PrivateRoute
            path={`${pathname.proposal.approve.notApproveCancelMulti}`}
            exact
            component={NotApproveCancelMulti}
          />
          {/* setting*/}
          <PrivateRoute
            path={`${pathname.admin.adminReport.ProjectInfoAccordingReviewCycle}`}
            exact
            component={ProjectInfoAccordingReviewCycle}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.PreApprovedProject}`}
            exact
            component={PreApprovedProject}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.ApprovedProject}`}
            exact
            component={ApprovedProject}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.ProjectActiveSeparateIssues}`}
            exact
            component={ProjectActiveSeparateIssues}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.ProjectChangedStatusProcess}`}
            exact
            component={ProjectChangedStatusProcess}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.ContractCenterProjectTracking}`}
            exact
            component={ContractCenterProjectTracking}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.ProjectTracking}`}
            exact
            component={ProjectTracking}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.ProjectClosedLate}`}
            exact
            component={ProjectClosedLate}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.ProjectDisbursementByPeriod}`}
            exact
            component={ProjectDisbursementByPeriod}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.SubProjectReportAdmin}`}
            exact
            component={SubProjectReportAdmin}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.DocumentDeliveryAddress}`}
            exact
            component={DocumentDeliveryAddress}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.ProjectApproved}`}
            exact
            component={ProjectApproved}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.ActiveProjectForContract}`}
            exact
            component={ActiveProjectForContract}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.ProjectWaitingForClose}`}
            exact
            component={ProjectWaitingForClose}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.ProjectClose}`}
            exact
            component={ProjectClose}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.ProjectGrant}`}
            exact
            component={ProjectGrant}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.OverduePaymentPeriod}`}
            exact
            component={OverduePaymentPeriod}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.ObligationOfInstallment}`}
            exact
            component={ObligationOfInstallment}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.BudgetApprovalReport}`}
            exact
            component={BudgetApprovalReport}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.ConfirmActualResult}`}
            exact
            component={ConfirmActualResult}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.ProjectBudgetPlanReport}`}
            exact
            component={ProjectBudgetPlanReport}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.AccessLoggerActivity}`}
            exact
            component={AccessLoggerActivity}
          />

          <PrivateRoute
            path={`${pathname.admin.adminReport.Obligation}`}
            exact
            component={Obligation}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.AllProjectSummaryReport}`}
            exact
            component={AllProjectSummaryReport}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.OverallBudgetReport}`}
            exact
            component={OverallBudgetReport}
          />

          <PrivateRoute
            path={`${pathname.setting.dashboardSetting}`}
            exact
            component={DashboardSetting}
          />

          <PrivateRoute
            path={`${pathname.admin.adminReport.OverallDisbursementReport}`}
            exact
            component={OverallDisbursementReport}
          />

          {/* admin manage*/}
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageCommitteeAccounts}`}
            exact
            component={ManageCommitteeAccounts}
          />
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageExpertAccounts}`}
            exact
            component={ManageExpertAccounts}
          />
          <PrivateRoute
            path={`${pathname.search.ManageExpertAccountsViewOnly}`}
            exact
            component={ManageExpertAccountsViewOnly}
          />
          <PrivateRoute path={`${pathname.search.CheckApproval}`} exact component={CheckApproval} />
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageProjectClosedLate}`}
            exact
            component={ManageProjectClosedLate}
          />
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageLawProjectTracking}`}
            exact
            component={ManageLawProjectTracking}
          />
          <PrivateRoute
            path={`${pathname.search.ProposalAllDetail}`}
            exact
            component={ProposalAllDetail}
          />
          <PrivateRoute
            path={`${pathname.search.ProjectGranteeBasicInfo}`}
            exact
            component={ProjectGranteeBasicInfo}
          />

          <PrivateRoute
            path={`${pathname.assessment.assessmentSettingPage}`}
            exact
            component={AddEvaluationPage}
          />
          <PrivateRoute
            path={`${pathname.assessment.assessmentSettingType}`}
            exact
            component={AddEvaluationType}
          />
          <PrivateRoute
            path={`${pathname.assessment.assessmentSettingAddForm}`}
            exact
            component={AddEvaluationForm}
          />
          <PrivateRoute
            path={`${pathname.assessment.assessmentSettingForm}`}
            exact
            component={EvaluationForm}
          />
          <PrivateRoute
            path={`${pathname.assessment.assessmentSettingMasterQuestion}`}
            exact
            component={AddMasterQuestion}
          />

          <PrivateRoute
            path={`${pathname.assessment.assessmentMAndE}`}
            exact
            component={MAndEMain}
          />
          <PrivateRoute
            path={`${pathname.assessment.assessmentMAndEForm}`}
            exact
            component={MAndEForm}
          />
          <PrivateRoute
            path={`${pathname.assessment.assessmentMAndESelf}`}
            exact
            component={MAndESelfMain}
          />
          <PrivateRoute
            path={`${pathname.assessment.assessmentMAndESelfList}`}
            exact
            component={MAndESelfMainAll}
          />

          <PrivateRoute
            path={`${pathname.assessment.assessmentMAndESelfForm}`}
            exact
            component={MAndESelfForm}
          />
          <PrivateRoute
            path={`${pathname.assessment.assessmentMAndEManageCBTeam}`}
            exact
            component={MAndEManageCBTeam}
          />

          <PrivateRoute
            path={`${pathname.assessment.assessmentPrePostTestPreview}`}
            exact
            component={PrePostTestPreview}
          />

          <PrivateRoute
            path={`${pathname.assessment.assessmentReportPartnerStrength}`}
            exact
            component={ReportPartnerStrength}
          />
          <PrivateRoute
            path={`${pathname.assessment.assessmentReprotProjectManagement}`}
            exact
            component={ReportProjectManagement}
          />
          <PrivateRoute
            path={`${pathname.assessment.assessmentReprotHealthPromotionProject}`}
            exact
            component={ReprotHealthPromotionProject}
          />
          <PrivateRoute
            path={`${pathname.assessment.assessmentReprotCompetenciesAssessment}`}
            exact
            component={ReprotCompetenciesAssessment}
          />
          <PrivateRoute
            path={`${pathname.assessment.assessmentReprotCompetenciesPartner}`}
            exact
            component={ReprotCompetenciesPartner}
          />
          <PrivateRoute
            path={`${pathname.assessment.assessmentReprotUnitCompetency}`}
            exact
            component={ReportUnitCompetency}
          />
          <PrivateRoute
            path={`${pathname.assessment.assessmentReprotEvaluationScore}`}
            exact
            component={ReportEvaluationScore}
          />

          <PrivateRoute
            path={`${pathname.assessment.assessmentSettingManageUnitType}`}
            exact
            component={MasterSeting}
          />

          <PrivateRoute
            path={`${pathname.assessment.assessmentImportNodeData}`}
            exact
            component={ImportNodeData}
          />
          <PrivateRoute
            path={`${pathname.search.ProjectVenderLists}`}
            exact
            component={ProjectVenderList}
          />

          <PrivateRoute path={`${pathname.law.ManageLegal}`} exact component={ManageLegal} />
          <PrivateRoute path={`${pathname.law.SaveLawList}`} exact component={SaveLawList} />
          <PrivateRoute
            path={`${pathname.law.SaveLawTracking}`}
            exact
            component={SaveLawTracking}
          />
          <PrivateRoute path={`${pathname.law.CallBookNotice}`} exact component={CallBookNotice} />
          <PrivateRoute path={`${pathname.law.CheckNotice}`} exact component={CheckNotice} />
          <PrivateRoute
            path={`${pathname.law.DocumentOfTermination}`}
            exact
            component={DocumentOfTermination}
          />
          <PrivateRoute
            path={`${pathname.law.TrackingHistoryLaw}`}
            exact
            component={TrackingHistoryLaw}
          />
          <PrivateRoute
            path={`${pathname.law.LawDocumentform}`}
            exact
            component={LawDocumentform}
          />
          <PrivateRoute path={`${pathname.law.LawApprove}`} exact component={LawApprove} />
          <PrivateRoute
            path={`${pathname.proposal.notaccepted.reviewSend}`}
            exact
            component={ReviewSend}
          />
          {/* เบิกค่ากลั่นกรองทางวิชาการ*/}
          <PrivateRoute
            path={`${pathname.admin.adminWithdrawalReview.sendWithdrawReview}`}
            exact
            component={SendWithdrawReview}
          />
          <PrivateRoute
            path={`${pathname.admin.adminWithdrawalReview.withdrawReview}`}
            exact
            component={ApproveWithdrawReview}
          />
          <PrivateRoute
            path={`${pathname.admin.adminWithdrawalReview.sendWithdrawReviewByReviewer}`}
            exact
            component={SendWithdrawReviewByReviewer}
          />
          <PrivateRoute
            path={`${pathname.admin.adminWithdrawalReview.withdrawReviewByReviewer}`}
            exact
            component={ApproveWithdrawReviewByReviewer}
          />
          {/* manage*/}
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageProjectStatus}`}
            exact
            component={ManageProjectStatus}
          />
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageProjectCoordinator}`}
            exact
            component={ManageProjectCoordinator}
          />
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageProhibited}`}
            exact
            component={ManageProhibited}
          />
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageMasterDataPreName}`}
            exact
            component={ManageMasterDataPreName}
          />
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageMasterDataSetting}`}
            exact
            component={ManageMasterDataSetting}
          />
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageMasterDataTarget}`}
            exact
            component={ManageMasterDataTarget}
          />
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageMasterDataIssue}`}
            exact
            component={ManageMasterDataIssue}
          />
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageMasterDataLawType}`}
            exact
            component={ManageMasterDataLawType}
          />
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageMasterDataLawStatus}`}
            exact
            component={ManageMasterDataLawStatus}
          />
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageMasterDataLocationType}`}
            exact
            component={ManageMasterDataLocationType}
          />
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageMasterDataThaihealthPlan}`}
            exact
            component={ManageMasterDataThaihealthPlan}
          />
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManagePermissions}`}
            exact
            component={ManagePermissions}
          />
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageHoliday}`}
            exact
            component={ManageHoliday}
          />
          {/* subProject */}
          <PrivateRoute
            path={`${pathname.subProject.subProjectDashboard}`}
            exact
            component={SubProjectDashboard}
          />
          {/* <PrivateRoute
            path={`${pathname.subProject.subProjectPage}`}
            exact
            component={SubProjectPage}
          /> */}
          <PrivateRoute
            path={`${pathname.subProject.overviewSubProject}`}
            exact
            component={OverviewSubProject}
          />
          <PrivateRoute
            path={`${pathname.subProject.searchSubproject}`}
            exact
            component={SearchSubproject}
          />
          <PrivateRoute
            path={`${pathname.subProject.projectMonitorRecord}`}
            exact
            component={ProjectMonitorRecord}
          />
          <PrivateRoute
            path={`${pathname.subProject.projectInfoDoc}`}
            exact
            component={ProjectInfoDoc}
          />
          <PrivateRoute
            path={`${pathname.subProject.SearchForNames}`}
            exact
            component={SearchForNames}
          />
          <PrivateRoute
            path={`${pathname.subProject.projectIndicators}`}
            exact
            component={ProjectIndicators}
          />
          <PrivateRoute
            path={`${pathname.subProject.projectIndicatorsDetails}`}
            exact
            component={ProjectIndicatorsDetails}
          />
          <PrivateRoute
            path={`${pathname.subProject.trackingHistory}`}
            exact
            component={TrackingHistory}
          />
          <PrivateRoute
            path={`${pathname.subProject.projectMonitorRecordFollow}`}
            exact
            component={ProjectMonitorRecordFollow}
          />
          <PrivateRoute
            path={`${pathname.subProject.checkProjectQuality}`}
            exact
            component={CheckProjectQuality}
          />
          <PrivateRoute
            path={`${pathname.subProject.projectCommentsRecord}`}
            exact
            component={ProjectCommentsRecord}
          />
          {/* review */}
          <PrivateRoute
            path={`${pathname.subProject.reviewSubproject.assignExpertSub}`}
            exact
            component={AssignExpertSub}
          />
          <PrivateRoute
            path={`${pathname.subProject.reviewSubproject.reviewSummarySub}`}
            exact
            component={ReviewSummarySub}
          />
          <PrivateRoute
            path={`${pathname.subProject.reviewSubproject.saveReviewSubproject}`}
            exact
            component={SaveReviewSubproject}
          />
          <PrivateRoute
            path={`${pathname.subProject.reviewSubproject.proposalReviseSub}`}
            exact
            component={ProposalReviseSub}
          />
          <PrivateRoute
            path={`${pathname.subProject.reviewSubproject.paymentSaveSub}`}
            exact
            component={PaymentSaveSub}
          />
          {/* approve */}
          <PrivateRoute
            path={`${pathname.subProject.approve.paymentCheckSubproject}`}
            exact
            component={PaymentCheckSubproject}
          />
          <PrivateRoute
            path={`${pathname.subProject.approve.granteeForStaffSubproject}`}
            exact
            component={GranteeForStaffSubproject}
          />
          <PrivateRoute
            path={`${pathname.subProject.approve.sentToFixSubproject}`}
            exact
            component={SentToFixSubproject}
          />
          <PrivateRoute
            path={`${pathname.subProject.approve.subProjectApprovalSummaryForStaff}`}
            exact
            component={SubProjectApprovalSummaryForStaff}
          />
          {/* progress report */}
          <PrivateRoute
            path={`${pathname.subProject.projectManagement.progressReportSubproject}`}
            exact
            component={ProgressReportSubproject}
          />
          <PrivateRoute
            path={`${pathname.subProject.projectManagement.progressReportSubprojectClose}`}
            exact
            component={progressReportSubprojectClose}
          />
          <PrivateRoute
            path={`${pathname.subProject.projectManagement.periodicFinancialReport}`}
            exact
            component={PeriodicFinancialReport}
          />
          <PrivateRoute
            path={`${pathname.subProject.projectManagement.periodicFinancialReportClose}`}
            exact
            component={PeriodicFinancialReportClose}
          />
          {/* withdraw */}
          <PrivateRoute
            path={`${pathname.subProject.withdraw.withdrawRequestSubproject}`}
            exact
            component={WithdrawRequestSubproject}
          />
          <PrivateRoute
            path={`${pathname.subProject.subProjectTypeInfo}`}
            exact
            component={SubProjectTypeInfo}
          />
          <PrivateRoute
            path={`${pathname.subProject.contract}`}
            exact
            component={SubProjectContract}
          />
          <PrivateRoute
            path={`${pathname.subProject.targetSettingSubProject}`}
            exact
            component={TargetSettingSubProject}
          />
          <PrivateRoute
            path={`${pathname.subProject.subProjectName}`}
            exact
            component={SubProjectName}
          />
          <PrivateRoute
            path={`${pathname.subProject.objectiveGoalSub}`}
            exact
            component={ObjectiveGoalSub}
          />
          <PrivateRoute
            path={`${pathname.subProject.budgetSubProject}`}
            exact
            component={BudgetSubProject}
          />
          <PrivateRoute
            path={`${pathname.subProject.granteeBasicInfoSub}`}
            exact
            component={GranteeBasicInfoSub}
          />
          <PrivateRoute
            path={`${pathname.subProject.responsibleManBasicInfoSub}`}
            exact
            component={ResponsibleManBasicInfoSub}
          />
          <PrivateRoute
            path={`${pathname.subProject.setting.reportSetting}`}
            exact
            component={reportSetting}
          />
          <PrivateRoute
            path={`${pathname.subProject.setting.manageUserGroups}`}
            exact
            component={manageUserGroups}
          />
          <PrivateRoute
            path={`${pathname.subProject.setting.manageUserRole}`}
            exact
            component={manageUserRole}
          />
          <PrivateRoute
            path={`${pathname.subProject.setting.manageEvaluationTeamRole}`}
            exact
            component={ManageEvaluationTeamRole}
          />
          <PrivateRoute
            path={`${pathname.subProject.setting.importUserRole}`}
            exact
            component={ImportUserRole}
          />
          <PrivateRoute
            path={`${pathname.subProject.report.approvalFormReport}`}
            exact
            component={SubApprovalFormReport}
          />
          <PrivateRoute
            path={`${pathname.subProject.report.summaryReport}`}
            exact
            component={SubAummaryReport}
          />
          <PrivateRoute
            path={`${pathname.subProject.report.grantReport}`}
            exact
            component={SubGrantReport}
          />
          <PrivateRoute
            path={`${pathname.subProject.report.billPaymentReport}`}
            exact
            component={SubBillPaymentReport}
          />
          <PrivateRoute
            path={`${pathname.subProject.report.subProjectApprovalReport}`}
            exact
            component={SubProjectApprovalReport}
          />
          <PrivateRoute
            path={`${pathname.subProject.report.progressiveReport}`}
            exact
            component={ProgressiveReport}
          />
          <PrivateRoute
            path={`${pathname.subProject.saveProgressive}`}
            exact
            component={SaveProgressive}
          />
          <PrivateRoute
            path={`${pathname.subProject.report.projectControlReport}`}
            exact
            component={ProjectControlReport}
          />
          <PrivateRoute
            path={`${pathname.subProject.report.subProjectReport}`}
            exact
            component={SubProjectReport}
          />
          <PrivateRoute
            path={`${pathname.subProject.report.installmentReport}`}
            exact
            component={InstallmentReport}
          />
          <PrivateRoute
            path={`${pathname.subProject.users.usersRole}`}
            exact
            component={UsesRoleSubProject}
          />
          <PrivateRoute
            path={`${pathname.subProject.users.createUser}`}
            exact
            component={CreateUserSubProject}
          />
          <PrivateRoute
            path={`${pathname.subProject.closeProject}`}
            exact
            component={SubCloseProject}
          />
          <PrivateRoute
            path={`${pathname.subProject.changeSubProjectStatus}`}
            exact
            component={ChangeSubProjectStatus}
          />
          <PrivateRoute
            path={`${pathname.proposal.approve.paymentApprove}`}
            exact
            component={PaymentApproveRedirect}
          />
          <PrivateRoute
            path={`${pathname.proposal.approve.projectApprove}`}
            exact
            component={ProjectApproveRedirect}
          />
          <PrivateRoute
            path={`${pathname.proposal.approve.closeApprove}`}
            exact
            component={CloseProjectApproveRedirect}
          />
          <PrivateRoute
            path={`${pathname.proposal.approve.TerminateApprove}`}
            exact
            component={TerminateApproveRedirect}
          />
          <PrivateRoute
            path={`${pathname.proposal.approve.modifyContractApprove}`}
            exact
            component={ModifyContractApproveRedirect}
          />
          <PrivateRoute
            path={`${pathname.manageConsiderationRound}`}
            exact
            component={ManageConsiderationRound}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.MainIncomAndExpense}`}
            exact
            component={MainIncomAndExpense}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.MainApprover}`}
            exact
            component={MainIncomAndExpenseApprover}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.ProjectBasedItems}`}
            exact
            component={ProjectBasedItems}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.IncomeRecord}`}
            exact
            component={IncomeRecord}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.ExpenseRecord}`}
            exact
            component={ExpenseRecord}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.StrategyRegister}`}
            exact
            component={StrategyRegister}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.ManageSubStrategy}`}
            exact
            component={ManageSubStrategy}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.ManageBankAccount}`}
            exact
            component={ManageBankAccount}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.UpdateList}`}
            exact
            component={UpdateList}
          />
          {/* ประเมินการการทำงานร่วมกับ สสส. */}
          <PrivateRoute
            path={`${pathname.proposal.assessment.assessmentOfWorkingWithThaiHealth}`}
            exact
            component={AssessmentOfWorkingWithThaiHealth}
          />
          {/* ครุภัณฑ์ */}
          <PrivateRoute
            path={`${pathname.durableArticles.AddDurableArticles}`}
            exact
            component={AddDurableArticles}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.DurableArticlesHistory}`}
            exact
            component={AssetHistory}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.AssetSendBackEditLists}`}
            exact
            component={AssetSendBackEditLists}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.AssetBookingManagement}`}
            exact
            component={AssetBookingManagement}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.AssetBookingManagementDetail}`}
            exact
            component={AssetBookingManagementDetail}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.AssetRequestManagement}`}
            exact
            component={AssetRequestManagement}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.AssetRequestManagementDetail}`}
            exact
            component={AssetRequestManagementDetail}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.AssetRequestManagementApprove}`}
            exact
            component={AssetRequestManagementApprove}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.AssetBookingManagementOfficer}`}
            exact
            component={AssetBookingManagementOfficer}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.AssetBookingManagementDetailOfficer}`}
            exact
            component={AssetBookingManagementDetailOfficer}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.AssetBookingLists}`}
            exact
            component={AssetBookingLists}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.ListDurableArticles}`}
            exact
            component={ListDurableArticles}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.ClosureDurableArticles}`}
            exact
            component={ClosureDurableArticles}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.ManageDurableArticles}`}
            exact
            component={ClosureRequestDurableArticles}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.ManageAssetRevolving}`}
            exact
            component={ManageAssetRevolving}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.AssetCounting}`}
            exact
            component={AssetCounting}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.AddAssetCounting}`}
            exact
            component={AddAssetCounting}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.MigrationDurableArticles}`}
            exact
            component={AssetMigration}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.AssetCountingSupplyOfficer}`}
            exact
            component={AssetCountingSupplyOfficer}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.AddAssetCountingSupplyOfficer}`}
            exact
            component={AddAssetCountingSupplyOfficer}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.ListOfAssetsOfficer}`}
            exact
            component={ListOfAssetsOfficer}
          />

          <PrivateRoute
            path={`${pathname.durableArticles.ListOfAssets}`}
            exact
            component={ListOfAssets}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.ListDepreciationAssets}`}
            exact
            component={ListDepreciationAssets}
          />

          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageNotificationAsset}`}
            exact
            component={ManageNotificationAsset}
          />
          <PrivateRoute
            path={`${pathname.admin.adminManage.ManageNotificationElse}`}
            exact
            component={ManageNotificationElse}
          />
          {/* <PrivateRoute
            path={`${pathname.durableArticles.NotificationOfAssets}`}
            exact
            component={NotificationOfAssets}
          /> */}
          {/* <PrivateRoute
            path={`${pathname.durableArticles.ApprovalCloseProject}`}
            exact
            component={ApprovalCloseProject}
          /> */}
          <PrivateRoute
            path={`${pathname.durableArticles.ClosureApproveRequest1}`}
            exact
            component={ClosureApproveRequestStep1}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.ClosureApproval1}`}
            exact
            component={ClosureApproveApproveStep1}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.ClosureApproveRequest2}`}
            exact
            component={ClosureApproveRequestStep2}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.ClosureApproval2}`}
            exact
            component={ClosureApproveApproveStep2}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.BookingManagementScholars}`}
            exact
            component={BookingManagementScholars}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.AssetQrCodeReport}`}
            exact
            component={AssetQrCodeReport}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.AssetRegisterReport}`}
            exact
            component={AssetRegisterReport}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.AssetStatusReport}`}
            exact
            component={AssetStatusReport}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.ApproverAssetRegisterReport}`}
            exact
            component={AssetRegisterReportApprover}
          />
          <PrivateRoute
            path={`${pathname.durableArticles.ApproverAssetStatusReport}`}
            exact
            component={AssetStatusReportApprover}
          />

          <PrivateRoute
            path={`${pathname.incomeAndExpense.eFillingListForm}`}
            exact
            component={eFillingListForm}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.ViewFileseFilling}`}
            exact
            component={ViewFileseFilling}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.eFillingListReport}`}
            exact
            component={eFillingListReport}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.eFillingSummaryReport}`}
            exact
            component={eFillingSummaryReport}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.AnnualTaxRemittance}`}
            exact
            component={AnnualTaxRemittance}
          />

          <PrivateRoute
            path={`${pathname.incomeAndExpense.eFillingListFormApprover}`}
            exact
            component={eFillingListFormApprover}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.eFillingListReportApprover}`}
            exact
            component={eFillingListReportApprover}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.eFillingSummaryReportApprover}`}
            exact
            component={eFillingSummaryReportApprover}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.AnnualTaxRemittanceApprover}`}
            exact
            component={AnnualTaxRemittanceApprover}
          />

          {/* บันทึกจ่ายเงินยืมทดลอง */}
          <PrivateRoute
            path={`${pathname.incomeAndExpense.BorrowAdvancePaymentRecord}`}
            exact
            component={PaymentRecordAdvance}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.BorrowAdvanceRefund}`}
            exact
            component={AdvanceRefund}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.CreatePayeeAndTaxInfo}`}
            exact
            component={CreatePayeeAndTaxInfo}
          />
          <PrivateRoute path={`${pathname.subProjectList}`} exact component={SubProjectList} />
          <PrivateRoute
            path={`${pathname.financialManagement.FinancialManagement}`}
            exact
            component={FinancialManagement}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.DailyPayBook}`}
            exact
            component={DailyPayBook}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.PeriodicManagement}`}
            exact
            component={PeriodicManagement}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.VoucherList}`}
            exact
            component={VoucherList}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.report.FinancialReportsDelivered}`}
            exact
            component={FinancialReportsDelivered}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.report.BorrowAdvanceReport}`}
            exact
            component={BorrowAvanceReport}
          />

          <PrivateRoute
            path={`${pathname.incomeAndExpense.report.TaxSumReport}`}
            exact
            component={TaxSumReport}
          />

          <PrivateRoute
            path={`${pathname.incomeAndExpense.report.SubprojecteReport}`}
            exact
            component={AccountingSubProjectReport}
          />
          <PrivateRoute path={`${pathname.incomeAndExpense.report.Cash}`} exact component={Cash} />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.report.Deposit}`}
            exact
            component={Deposit}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.SubProjectMainIncomAndExpense}`}
            exact
            component={SubProjectIncomeAndExpense}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.SubProjectProjectBasedItems}`}
            exact
            component={SubProjectBasedItems}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.SubProjectVoucherList}`}
            exact
            component={SubProjectVoucherList}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.BorrowAvanceVoucherList}`}
            exact
            component={BorrowAvanceVoucherList}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.UpdateListVoucherList}`}
            exact
            component={UpdateListVoucherList}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.ExpenseCheckList}`}
            exact
            component={CheckVoucherList}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.ExpenseCheckManage}`}
            exact
            component={ExpenseCheck}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.SubProjectExpenseRecord}`}
            exact
            component={SubprojectExpenseRecord}
          />
          {/* งานตรวจสอบ */}
          <PrivateRoute path={`${pathname.audit.ReportsAudit}`} exact component={ReportsAudit} />
          <PrivateRoute
            path={`${pathname.audit.AuditFileImport}`}
            exact
            component={AuditFileImport}
          />
          <PrivateRoute
            path={`${pathname.audit.AuditImportGrade}`}
            exact
            component={AuditFileImportGeade}
          />

          <PrivateRoute
            path={`${pathname.audit.FollowAuditIssues}`}
            exact
            component={FollowAuditIssues}
          />
          <PrivateRoute
            path={`${pathname.audit.AuditReportSummary}`}
            exact
            component={AuditReportSummary}
          />
          <PrivateRoute
            path={`${pathname.audit.ListReportIssues}`}
            exact
            component={ListReportIssues}
          />
          <PrivateRoute
            path={`${pathname.audit.DirectorFollowAuditIssues}`}
            exact
            component={DirectorFollowAuditIssues}
          />
          <PrivateRoute
            path={`${pathname.audit.FundManagerAuditIssues}`}
            exact
            component={FundManagerAuditIssues}
          />
          <PrivateRoute
            path={`${pathname.audit.AuditDucumentManagement}`}
            exact
            component={AuditDucumentManagement}
          />

          <PrivateRoute
            path={`${pathname.audit.AuditEmailAttManagement}`}
            exact
            component={EmailAttManagement}
          />

          <PrivateRoute
            path={`${pathname.audit.PrepareProjectReview}`}
            exact
            component={PrepareProjectReview}
          />
          <PrivateRoute
            path={`${pathname.audit.AuditDashboard}`}
            exact
            component={AuditDashboard}
          />
          <PrivateRoute
            path={`${pathname.incomeAndExpense.SubProjectIncomeRecord}`}
            exact
            component={SubProjectIncomeRecord}
          />
          {/* การประเมินก่อนปิดโครงการ */}
          <PrivateRoute
            path={`${pathname.evaluates.CoworkerEvaluateThaihealth}`}
            exact
            component={CoworkerEvaluateThaihealth}
          />
          <PrivateRoute
            path={`${pathname.evaluates.CoworkerEvaluateYourself}`}
            exact
            component={CoworkerEvaluateYourself}
          />
          <PrivateRoute
            path={`${pathname.evaluates.CoordinatorEvaluateCoworker}`}
            exact
            component={CoordinatorEvaluateCoworker}
          />
          <PrivateRoute
            path={`${pathname.evaluates.DirectorEvaluateCloseProject}`}
            exact
            component={DirectorEvaluateCloseProject}
          />
          <PrivateRoute
            path={`${pathname.SearchExpertPayment}`}
            exact
            component={SearchExpertPayment}
          />
          {/* รายการผู้ทิ้งงาน */}
          <PrivateRoute path={`${pathname.blacklist.Blacklisted}`} exact component={Blacklisted} />
          <PrivateRoute
            path={`${pathname.blacklist.AddBlacklist}`}
            exact
            component={AddBlacklist}
          />
          {/* infoma */}
          <PrivateRoute
            path={`${pathname.infoma.InfomaUploadFiles}`}
            exact
            component={InfomaUploadFiles}
          />
          {/* ProjectBudgetReport */}
          <PrivateRoute
            path={`${pathname.ProjectBudgetReport}`}
            exact
            component={ProjectBudgetReport}
          />
          {/* ProjectContractReport */}
          <PrivateRoute
            path={`${pathname.ProjectContractReport}`}
            exact
            component={ProjectContractReport}
          />

          <Route path={`${pathname.thaID.authen}`} exact component={IdentityLanding} />
          <Route path={`${pathname.thaID.callback}`} exact component={ResultIdentity} />
          {/* new subproject */}
          {/* จัดการ */}
          <PrivateRoute
            path={`${pathname.subProjectNew.settingProposal.templeteManage}`}
            exact
            component={ManageProposalForm}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.settingProposal.templeteDetail}`}
            exact
            component={TempletDetailForm}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.proposalSubmit}`}
            exact
            component={SubmitProposal}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.subProjectListSratusReport}`}
            exact
            component={ProjectListStatusReport}
          />
          {/* 1 */}
          <PrivateRoute
            path={`${pathname.subProjectNew.proposal.projectName}`}
            exact
            component={SubProjectNameNew}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.settingProposal.projectName}`}
            exact
            component={SubProjectNameNewSetting}
          />
          {/* 2 */}
          <PrivateRoute
            path={`${pathname.subProjectNew.proposal.projectProponent}`}
            exact
            component={ProjectProponent}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.settingProposal.projectProponent}`}
            exact
            component={ProjectProponentSetting}
          />
          {/* 3 */}
          <PrivateRoute
            path={`${pathname.subProjectNew.proposal.projectResponsibler}`}
            exact
            component={ProjectResponsibler}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.settingProposal.projectResponsibler}`}
            exact
            component={ProjectResponsiblerSetting}
          />
          {/* 4 */}
          <PrivateRoute
            path={`${pathname.subProjectNew.proposal.projectCoMaker}`}
            exact
            component={ProjectCoMaker}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.settingProposal.projectCoMaker}`}
            exact
            component={ProjectCoMakerSetting}
          />
          {/* 5 */}
          <PrivateRoute
            path={`${pathname.subProjectNew.proposal.projectFeature}`}
            exact
            component={ProjectFeature}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.settingProposal.projectFeature}`}
            exact
            component={ProjectFeatureSetting}
          />
          {/* 6 */}
          <PrivateRoute
            path={`${pathname.subProjectNew.proposal.projectBackground}`}
            exact
            component={ProjectBackground}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.settingProposal.projectBackground}`}
            exact
            component={ProjectBackgroundSetting}
          />
          {/* 7 Nomarl */}
          <PrivateRoute
            path={`${pathname.subProjectNew.proposal.projectGoal}`}
            exact
            component={SubProjectProposalGoal}
          />
          {/* 7 */}
          <PrivateRoute
            path={`${pathname.subProjectNew.proposal.projectObjectiveOutcomeIndicator}`}
            exact
            component={ProjectObjectiveOutcomeIndicator}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.settingProposal.projectObjectiveOutcomeIndicator}`}
            exact
            component={ProjectObjectiveOutcomeIndicatorSetting}
          />
          {/* 8 */}
          <PrivateRoute
            path={`${pathname.subProjectNew.proposal.targetOperationArea}`}
            exact
            component={ProjectTargetOperationArea}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.settingProposal.targetOperationArea}`}
            exact
            component={ProjectTargetOperationAreaSetting}
          />
          {/* 9 */}
          <PrivateRoute
            path={`${pathname.subProjectNew.proposal.operatingPeriod}`}
            exact
            component={OperatingPeriod}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.settingProposal.operatingPeriod}`}
            exact
            component={OperatingPeriodSetting}
          />
          {/* 10 */}
          <PrivateRoute
            path={`${pathname.subProjectNew.proposal.activities}`}
            exact
            component={Activities}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.settingProposal.activities}`}
            exact
            component={ActivitiesSetting}
          />
          {/* 11 */}
          <PrivateRoute
            path={`${pathname.subProjectNew.proposal.otherSupport}`}
            exact
            component={OtherSupport}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.settingProposal.otherSupport}`}
            exact
            component={OtherSupportSetting}
          />
          {/* 12 */}
          <PrivateRoute
            path={`${pathname.subProjectNew.proposal.resultsReport}`}
            exact
            component={ResultsReport}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.settingProposal.resultsReport}`}
            exact
            component={ResultsReportSetting}
          />
          {/* 13 */}
          <PrivateRoute
            path={`${pathname.subProjectNew.proposal.partner}`}
            exact
            component={Partner}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.settingProposal.partner}`}
            exact
            component={PartnerSetting}
          />
          {/* 13.1 */}
          <PrivateRoute
            path={`${pathname.subProjectNew.proposal.expectedResult}`}
            exact
            component={SubProjectExpectedResult}
          />

          {/* 14 */}
          <PrivateRoute
            path={`${pathname.subProjectNew.proposal.attachments}`}
            exact
            component={ProposalAttachments}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.settingProposal.attachments}`}
            exact
            component={ProposalAttachmentsSetting}
          />
          {/* 15 */}
          <PrivateRoute
            path={`${pathname.subProjectNew.proposal.appendix}`}
            exact
            component={Appendix}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.settingProposal.appendix}`}
            exact
            component={AppendixSetting}
          />
          {/* Subproject Review */}
          <PrivateRoute
            path={`${pathname.subProjectNew.review.paymentSave}`}
            exact
            component={PaymentSaveSubNew}
          />
          <PrivateRoute
            path={`${pathname.subProjectNew.review.reviewSave}`}
            exact
            component={SaveReviewSubprojectNew}
          />
          {/* ทำสัญญา */}
          <PrivateRoute
            path={`${pathname.subProjectNew.contract}`}
            exact
            component={SubProjectContractNew}
          />

          {/* รายงาน ประเมินคุณภาพข้อเสนอโครงการ */}
          <PrivateRoute
            path={`${pathname.admin.adminReport.AiEvaluationReport}`}
            exact
            component={AIEvaluationReportPage}
          />

          {/* ขอขยายระยะเวลา */}
          <PrivateRoute
            path={`${pathname.proposal.contract.contractChangeExtendPeriodForm}`}
            exact
            component={ContractChangeExtendPeriod}
          />
          <PrivateRoute
            path={`${pathname.proposal.contract.contractChangeExtendPeriodList}`}
            exact
            component={ContractChangeExtendPeriodHistory}
          />
          {/* รายงานขยายระยะเวลา */}
          <PrivateRoute
            path={`${pathname.admin.adminReport.ExtentionTimePerProjectReport}`}
            exact
            component={ExtentionTimePerProjectReport}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.ExtentionTimePerPeriodReport}`}
            exact
            component={ExtentionTimePerPeriodReport}
          />
          <PrivateRoute
            path={`${pathname.admin.adminReport.ExtentionTimeOverviewReport}`}
            exact
            component={ExtentionTimeOverviewReport}
          />
          <PrivateRoute
            render={() => {
              window.location.href = '/'
            }}
          />
        </Switch>
      </Router>
    </div>
  )
}
